/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 27);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = Immutable;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = ReactRedux;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(0);
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return State;
}(Immutable.Record({
    token: undefined,
    path: "",
    user: undefined,
    gameVersionTypes: undefined,
})));
exports.State = State;
exports.UPDATE_TOKEN = "brdgme/session/UPDATE_TOKEN";
exports.CLEAR_TOKEN = "brdgme/session/CLEAR_TOKEN";
exports.UPDATE_PATH = "brdgme/session/UPDATE_PATH";
exports.UPDATE_USER = "brdgme/session/UPDATE_USER";
exports.UPDATE_GAME_VERSION_TYPES = "brdgme/session/UPDATE_GAME_VERSION_TYPES";
exports.updateToken = function (token) { return ({
    type: exports.UPDATE_TOKEN,
    payload: token,
}); };
exports.clearToken = function () { return ({ type: exports.CLEAR_TOKEN }); };
exports.updatePath = function (path) { return ({
    type: exports.UPDATE_PATH,
    payload: path,
}); };
exports.updateUser = function (user) { return ({
    type: exports.UPDATE_USER,
    payload: user,
}); };
exports.updateGameVersionTypes = function (gameVersionTypes) { return ({
    type: exports.UPDATE_GAME_VERSION_TYPES,
    payload: gameVersionTypes,
}); };
function reducer(state, action) {
    if (state === void 0) { state = new State(); }
    switch (action.type) {
        case exports.UPDATE_TOKEN: return state.set("token", action.payload);
        case exports.CLEAR_TOKEN: return state.remove("token");
        case exports.UPDATE_PATH: return state.set("path", action.payload);
        case exports.UPDATE_USER: return state.set("user", action.payload);
        case exports.UPDATE_GAME_VERSION_TYPES:
            return state.set("gameVersionTypes", action.payload);
        default: return state;
    }
}
exports.reducer = reducer;


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return sym; });
/* unused harmony export TASK */
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MATCH; });
/* unused harmony export CANCEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["d"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return is; });
/* unused harmony export object */
/* harmony export (immutable) */ __webpack_exports__["n"] = remove;
/* unused harmony export array */
/* unused harmony export deferred */
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["f"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* unused harmony export uid */
/* harmony export (immutable) */ __webpack_exports__["l"] = makeIterator;
/* unused harmony export log */
/* harmony export (immutable) */ __webpack_exports__["g"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createSetContextWarning; });
/* unused harmony export wrapSagaDispatch */
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(0);
var Records = __webpack_require__(8);
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    State.prototype.updateGames = function (newGames) {
        return this.set("games", this.games.withMutations(function (games) {
            newGames.forEach(function (g) {
                if (g === undefined) {
                    return;
                }
                var existing = games.get(g.game.id);
                if (existing !== undefined) {
                    if (existing !== undefined && existing.game.updated_at > g.game.updated_at) {
                        // Our internal one is already newer.
                        return;
                    }
                    if (existing.game_player && !g.game_player) {
                        // We have a private view of the game, don't override with public.
                        return;
                    }
                }
                else {
                    existing = new Records.GameExtended();
                }
                games.set(g.game.id, existing.withMutations(function (ex) {
                    var existingLogs = ex.game_logs || Immutable.List();
                    ex.merge(g).set("game_logs", existingLogs.withMutations(function (logs) {
                        var logIds = logs.map(function (l) { return l.game_log.id; }).toSet();
                        if (g.game_logs !== undefined) {
                            g.game_logs.forEach(function (newLog) {
                                if (!logIds.contains(newLog.game_log.id)) {
                                    logs.push(newLog);
                                }
                            });
                        }
                    }));
                }));
            });
        }));
    };
    State.prototype.updateGamePlayer = function (gamePlayer) {
        if (!this.games.has(gamePlayer.game_id)) {
            return this;
        }
        return this.updateIn(["games", gamePlayer.game_id], function (game) { return game.withMutations(function (g) {
            if (g.game_player !== undefined && g.game_player.id === gamePlayer.id) {
                g.update("game_player", function (gp) { return gp && gp.merge(gamePlayer) || Records.GamePlayer.fromJS(gamePlayer); });
            }
            g.update("game_players", function (gps) { return gps.map(function (gpu) {
                if (gpu.game_player.id === gamePlayer.id) {
                    return gpu.update("game_player", function (gp) { return gp.merge(gamePlayer); });
                }
                return gpu;
            }).toList(); });
        }); });
    };
    return State;
}(Immutable.Record({
    games: Immutable.Map(),
})));
exports.State = State;
exports.FETCH_GAME = "brdgme/game/FETCH_GAME";
exports.FETCH_GAME_SUCCESS = "brdgme/game/FETCH_GAME_SUCCESS";
exports.FETCH_GAME_FAIL = "brdgme/game/FETCH_GAME_FAIL";
exports.UPDATE_GAMES = "brdgme/game/UPDATE_GAMES";
exports.SUBMIT_COMMAND = "brdgme/game/SUBMIT_COMMAND";
exports.SUBMIT_COMMAND_SUCCESS = "brdgme/game/SUBMIT_COMMAND_SUCCESS";
exports.SUBMIT_COMMAND_FAIL = "brdgme/game/SUBMIT_COMMAND_FAIL";
exports.SUBMIT_UNDO = "brdgme/game/SUBMIT_UNDO";
exports.SUBMIT_UNDO_SUCCESS = "brdgme/game/SUBMIT_UNDO_SUCCESS";
exports.SUBMIT_UNDO_FAIL = "brdgme/game/SUBMIT_UNDO_FAIL";
exports.SUBMIT_MARK_READ = "brdgme/game/SUBMIT_MARK_READ";
exports.SUBMIT_MARK_READ_SUCCESS = "brdgme/game/SUBMIT_MARK_READ_SUCCESS";
exports.SUBMIT_MARK_READ_FAIL = "brdgme/game/SUBMIT_MARK_READ_FAIL";
exports.SUBMIT_CONCEDE = "brdgme/game/SUBMIT_CONCEDE";
exports.SUBMIT_CONCEDE_SUCCESS = "brdgme/game/SUBMIT_CONCEDE_SUCCESS";
exports.SUBMIT_CONCEDE_FAIL = "brdgme/game/SUBMIT_CONCEDE_FAIL";
exports.SUBMIT_RESTART = "brdgme/game/SUBMIT_RESTART";
exports.SUBMIT_RESTART_SUCCESS = "brdgme/game/SUBMIT_RESTART_SUCCESS";
exports.SUBMIT_RESTART_FAIL = "brdgme/game/SUBMIT_RESTART_FAIL";
exports.GAME_RESTARTED = "brdgme/game/GAME_RESTARTED";
exports.fetchGame = function (id) { return ({
    type: exports.FETCH_GAME,
    payload: id,
}); };
exports.fetchGameSuccess = function (game) { return ({
    type: exports.FETCH_GAME_SUCCESS,
    payload: game,
}); };
exports.fetchGameFail = function () { return ({ type: exports.FETCH_GAME_FAIL }); };
exports.updateGames = function (games) { return ({
    type: exports.UPDATE_GAMES,
    payload: games,
}); };
exports.submitCommand = function (gameId, command) { return ({
    type: exports.SUBMIT_COMMAND,
    payload: { gameId: gameId, command: command },
}); };
exports.submitCommandSuccess = function (game) { return ({
    type: exports.SUBMIT_COMMAND_SUCCESS,
    payload: game,
}); };
exports.submitCommandFail = function (error) { return ({
    type: exports.SUBMIT_COMMAND_FAIL,
    payload: error,
}); };
exports.submitUndo = function (gameId) { return ({
    type: exports.SUBMIT_UNDO,
    payload: gameId,
}); };
exports.submitUndoSuccess = function (game) { return ({
    type: exports.SUBMIT_UNDO_SUCCESS,
    payload: game,
}); };
exports.submitUndoFail = function (error) { return ({
    type: exports.SUBMIT_UNDO_FAIL,
    payload: error,
}); };
exports.submitMarkRead = function (gameId) { return ({
    type: exports.SUBMIT_MARK_READ,
    payload: gameId,
}); };
exports.submitMarkReadSuccess = function (gamePlayer) { return ({
    type: exports.SUBMIT_MARK_READ_SUCCESS,
    payload: gamePlayer,
}); };
exports.submitMarkReadFail = function (error) { return ({
    type: exports.SUBMIT_MARK_READ_FAIL,
    payload: error,
}); };
exports.submitConcede = function (gameId) { return ({
    type: exports.SUBMIT_CONCEDE,
    payload: gameId,
}); };
exports.submitConcedeSuccess = function (game) { return ({
    type: exports.SUBMIT_CONCEDE_SUCCESS,
    payload: game,
}); };
exports.submitConcedeFail = function (error) { return ({
    type: exports.SUBMIT_CONCEDE_FAIL,
    payload: error,
}); };
exports.submitRestart = function (gameId) { return ({
    type: exports.SUBMIT_RESTART,
    payload: gameId,
}); };
exports.submitRestartSuccess = function (oldGameId, newGame) { return ({
    type: exports.SUBMIT_RESTART_SUCCESS,
    payload: { oldGameId: oldGameId, newGame: newGame },
}); };
exports.submitRestartFail = function (error) { return ({
    type: exports.SUBMIT_RESTART_FAIL,
    payload: error,
}); };
exports.gameRestarted = function (gameId, restartedGameId) { return ({
    type: exports.GAME_RESTARTED,
    payload: { gameId: gameId, restartedGameId: restartedGameId },
}); };
function reducer(state, action) {
    if (state === void 0) { state = new State(); }
    switch (action.type) {
        case exports.FETCH_GAME_SUCCESS: return state.updateGames(Records.GameExtended.fromJSList([action.payload]));
        case exports.UPDATE_GAMES: return state.updateGames(action.payload);
        case exports.SUBMIT_COMMAND_SUCCESS: return state.updateGames(Records.GameExtended.fromJSList([action.payload]));
        case exports.SUBMIT_MARK_READ_SUCCESS: return state.updateGamePlayer(action.payload);
        case exports.SUBMIT_CONCEDE_SUCCESS: return state.updateGames(Records.GameExtended.fromJSList([action.payload]));
        case exports.SUBMIT_RESTART_SUCCESS: return state
            .updateGames(Records.GameExtended.fromJSList([action.payload.newGame]))
            .updateIn(["games", action.payload.oldGameId, "game"], function (game) { return game.set("restarted_game_id", action.payload.newGame.game.id); });
        case exports.GAME_RESTARTED: return state.updateIn(["games", action.payload.gameId, "game"], function (game) { return game.set("restarted_game_id", action.payload.restartedGameId); });
        default: return state;
    }
}
exports.reducer = reducer;


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(7);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takem", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "put", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "race", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "call", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "apply", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cps", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fork", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "spawn", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "join", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "actionChannel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancelled", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["o"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["c"]; });




/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export detach */
/* harmony export (immutable) */ __webpack_exports__["q"] = take;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return takem; });
/* harmony export (immutable) */ __webpack_exports__["l"] = put;
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* harmony export (immutable) */ __webpack_exports__["m"] = race;
/* harmony export (immutable) */ __webpack_exports__["d"] = call;
/* harmony export (immutable) */ __webpack_exports__["c"] = apply;
/* harmony export (immutable) */ __webpack_exports__["g"] = cps;
/* harmony export (immutable) */ __webpack_exports__["i"] = fork;
/* harmony export (immutable) */ __webpack_exports__["p"] = spawn;
/* harmony export (immutable) */ __webpack_exports__["k"] = join;
/* harmony export (immutable) */ __webpack_exports__["e"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["n"] = select;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* harmony export (immutable) */ __webpack_exports__["f"] = cancelled;
/* harmony export (immutable) */ __webpack_exports__["h"] = flush;
/* harmony export (immutable) */ __webpack_exports__["j"] = getContext;
/* harmony export (immutable) */ __webpack_exports__["o"] = setContext;
/* unused harmony export asEffect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);


var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["o" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["p" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["p" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["h" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(0);
var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    User.fromJS = function (js) {
        return new User(js);
    };
    return User;
}(Immutable.Record({
    id: "",
    created_at: "",
    updated_at: "",
    name: "",
    pref_colors: Immutable.List(),
})));
exports.User = User;
var GameType = /** @class */ (function (_super) {
    __extends(GameType, _super);
    function GameType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameType.fromJS = function (js) {
        return new GameType(js);
    };
    return GameType;
}(Immutable.Record({
    id: "",
    created_at: "",
    updated_at: "",
    name: "",
    player_counts: Immutable.List(),
    weight: 0,
})));
exports.GameType = GameType;
var GameVersion = /** @class */ (function (_super) {
    __extends(GameVersion, _super);
    function GameVersion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameVersion.fromJS = function (js) {
        return new GameVersion(js);
    };
    return GameVersion;
}(Immutable.Record({
    id: "",
    created_at: "",
    updated_at: "",
    game_type_id: "",
    name: "",
    is_public: false,
    is_deprecated: false,
})));
exports.GameVersion = GameVersion;
var GameVersionType = /** @class */ (function (_super) {
    __extends(GameVersionType, _super);
    function GameVersionType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameVersionType.fromJS = function (js) {
        return new GameVersionType({
            game_version: GameVersion.fromJS(js.game_version),
            game_type: GameType.fromJS(js.game_type),
        });
    };
    return GameVersionType;
}(Immutable.Record({
    game_version: new GameVersion(),
    game_type: new GameType(),
})));
exports.GameVersionType = GameVersionType;
var Game = /** @class */ (function (_super) {
    __extends(Game, _super);
    function Game() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Game.fromJS = function (js) {
        return new Game(js);
    };
    return Game;
}(Immutable.Record({
    id: "",
    created_at: "",
    updated_at: "",
    game_version_id: "",
    is_finished: false,
    finished_at: undefined,
    chat_id: undefined,
    restarted_game_id: undefined,
})));
exports.Game = Game;
var GameTypeUser = /** @class */ (function (_super) {
    __extends(GameTypeUser, _super);
    function GameTypeUser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameTypeUser.fromJS = function (js) {
        return new GameTypeUser(js);
    };
    return GameTypeUser;
}(Immutable.Record({
    id: "",
    created_at: "",
    updated_at: "",
    game_type_id: "",
    user_id: "",
    rating: 0,
    peak_rating: 0,
})));
exports.GameTypeUser = GameTypeUser;
var GamePlayer = /** @class */ (function (_super) {
    __extends(GamePlayer, _super);
    function GamePlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GamePlayer.fromJS = function (js) {
        return new GamePlayer(js);
    };
    return GamePlayer;
}(Immutable.Record({
    id: "",
    created_at: "",
    updated_at: "",
    game_id: "",
    user_id: "",
    position: 0,
    color: "",
    has_accepted: false,
    is_turn: false,
    is_turn_at: "",
    last_turn_at: "",
    is_eliminated: false,
    is_read: false,
    points: undefined,
    can_undo: false,
    place: undefined,
    rating_change: undefined,
})));
exports.GamePlayer = GamePlayer;
var GameLog = /** @class */ (function (_super) {
    __extends(GameLog, _super);
    function GameLog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameLog.fromJS = function (js) {
        return new GameLog(js);
    };
    return GameLog;
}(Immutable.Record({
    id: "",
    created_at: "",
    updated_at: "",
    game_id: "",
    body: "",
    is_public: false,
    logged_at: "",
})));
exports.GameLog = GameLog;
var GameLogRendered = /** @class */ (function (_super) {
    __extends(GameLogRendered, _super);
    function GameLogRendered() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameLogRendered.fromJS = function (js) {
        return new GameLogRendered({
            game_log: GameLog.fromJS(js.game_log),
            html: js.html,
        });
    };
    return GameLogRendered;
}(Immutable.Record({
    game_log: new GameLog(),
    html: "",
})));
exports.GameLogRendered = GameLogRendered;
var GamePlayerTypeUser = /** @class */ (function (_super) {
    __extends(GamePlayerTypeUser, _super);
    function GamePlayerTypeUser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GamePlayerTypeUser.fromJS = function (js) {
        return new GamePlayerTypeUser({
            game_player: GamePlayer.fromJS(js.game_player),
            user: User.fromJS(js.user),
            game_type_user: GameTypeUser.fromJS(js.game_type_user),
        });
    };
    return GamePlayerTypeUser;
}(Immutable.Record({
    game_player: new GamePlayer(),
    user: new User(),
    game_type_user: new GameTypeUser(),
})));
exports.GamePlayerTypeUser = GamePlayerTypeUser;
var GameExtended = /** @class */ (function (_super) {
    __extends(GameExtended, _super);
    function GameExtended() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameExtended.fromJS = function (js) {
        return new GameExtended({
            game: Game.fromJS(js.game),
            game_type: GameType.fromJS(js.game_type),
            game_version: GameVersion.fromJS(js.game_version),
            game_player: js.game_player && GamePlayer.fromJS(js.game_player) || undefined,
            game_players: Immutable.List(js.game_players.map(GamePlayerTypeUser.fromJS)),
            game_logs: js.game_logs && Immutable.List(js.game_logs.map(GameLogRendered.fromJS)) || undefined,
            pub_state: js.pub_state,
            html: js.html,
            command_spec: js.command_spec && Immutable.fromJS(js.command_spec) || undefined,
            chat: js.chat && ChatExtended.fromJS(js.chat) || undefined,
        });
    };
    GameExtended.fromJSList = function (js) {
        return Immutable.List(js.map(GameExtended.fromJS));
    };
    return GameExtended;
}(Immutable.Record({
    game: new Game(),
    game_type: new GameType(),
    game_version: new GameVersion(),
    game_player: undefined,
    game_players: Immutable.List(),
    chat: undefined,
    game_logs: undefined,
    pub_state: undefined,
    html: undefined,
    command_spec: undefined,
})));
exports.GameExtended = GameExtended;
var Chat = /** @class */ (function (_super) {
    __extends(Chat, _super);
    function Chat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Chat.fromJS = function (js) {
        return new Chat(js);
    };
    return Chat;
}(Immutable.Record({
    id: "",
    created_at: "",
    updated_at: "",
})));
exports.Chat = Chat;
var ChatUser = /** @class */ (function (_super) {
    __extends(ChatUser, _super);
    function ChatUser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChatUser.fromJS = function (js) {
        return new ChatUser(js);
    };
    return ChatUser;
}(Immutable.Record({
    id: "",
    created_at: "",
    updated_at: "",
    chat_id: "",
    user_id: "",
    last_read_at: "",
})));
exports.ChatUser = ChatUser;
var ChatMessage = /** @class */ (function (_super) {
    __extends(ChatMessage, _super);
    function ChatMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChatMessage.fromJS = function (js) {
        return new ChatMessage(js);
    };
    return ChatMessage;
}(Immutable.Record({
    id: "",
    created_at: "",
    updated_at: "",
    chat_user_id: "",
    message: "",
})));
exports.ChatMessage = ChatMessage;
var ChatExtended = /** @class */ (function (_super) {
    __extends(ChatExtended, _super);
    function ChatExtended() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChatExtended.fromJS = function (js) {
        return new ChatExtended({
            chat: Chat.fromJS(js.chat),
            chat_users: Immutable.List(js.chat_users.map(ChatUser.fromJS)),
            chat_messages: Immutable.List(js.chat_messages.map(ChatMessage.fromJS)),
        });
    };
    return ChatExtended;
}(Immutable.Record({
    chat: new Chat(),
    chat_users: Immutable.List(),
    chat_messages: Immutable.List(),
})));
exports.ChatExtended = ChatExtended;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(0);
var Mode;
(function (Mode) {
    Mode[Mode["EnteringEmail"] = 0] = "EnteringEmail";
    Mode[Mode["SubmittingEmail"] = 1] = "SubmittingEmail";
    Mode[Mode["EnteringCode"] = 2] = "EnteringCode";
    Mode[Mode["SubmittingCode"] = 3] = "SubmittingCode";
})(Mode = exports.Mode || (exports.Mode = {}));
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return State;
}(Immutable.Record({
    code: "",
    email: "",
    mode: Mode.EnteringEmail,
})));
exports.State = State;
exports.UPDATE_EMAIL = "brdgme/pages/login/UPDATE_EMAIL";
exports.UPDATE_CODE = "brdgme/pages/login/UPDATE_CODE";
exports.UPDATE_MODE = "brdgme/pages/login/UPDATE_MODE";
exports.SUBMIT_EMAIL = "brdgme/pages/login/SUBMIT_EMAIL";
exports.SUBMIT_EMAIL_SUCCESS = "brdgme/pages/login/SUBMIT_EMAIL_SUCCESS";
exports.SUBMIT_EMAIL_FAIL = "brdgme/pages/login/SUBMIT_EMAIL_FAIL";
exports.SUBMIT_CODE = "brdgme/pages/login/SUBMIT_CODE";
exports.SUBMIT_CODE_SUCCESS = "brdgme/pages/login/SUBMIT_CODE_SUCCESS";
exports.SUBMIT_CODE_FAIL = "brdgme/pages/login/SUBMIT_CODE_FAIL";
exports.updateEmail = function (email) { return ({
    type: exports.UPDATE_EMAIL,
    payload: email,
}); };
exports.updateCode = function (code) { return ({
    type: exports.UPDATE_CODE,
    payload: code,
}); };
exports.updateMode = function (mode) { return ({
    type: exports.UPDATE_MODE,
    payload: mode,
}); };
exports.submitEmail = function (email) { return ({
    type: exports.SUBMIT_EMAIL,
    payload: email,
}); };
exports.submitEmailSuccess = function () { return ({
    type: exports.SUBMIT_EMAIL_SUCCESS,
}); };
exports.submitEmailFail = function () { return ({
    type: exports.SUBMIT_EMAIL_FAIL,
}); };
exports.submitCode = function (email, code) { return ({
    type: exports.SUBMIT_CODE,
    payload: { email: email, code: code },
}); };
exports.submitCodeSuccess = function (token) { return ({
    type: exports.SUBMIT_CODE_SUCCESS,
    payload: token,
}); };
exports.submitCodeFail = function () { return ({
    type: exports.SUBMIT_CODE_FAIL,
}); };
function reducer(state, action) {
    if (state === void 0) { state = new State(); }
    switch (action.type) {
        case exports.UPDATE_EMAIL: return state.set("email", action.payload);
        case exports.UPDATE_CODE: return state.set("code", action.payload);
        case exports.UPDATE_MODE: return state.set("mode", action.payload);
        case exports.SUBMIT_EMAIL: return state.set("mode", Mode.SubmittingEmail);
        case exports.SUBMIT_EMAIL_SUCCESS: return state.set("mode", Mode.EnteringCode);
        case exports.SUBMIT_EMAIL_FAIL: return state.set("mode", Mode.EnteringEmail);
        case exports.SUBMIT_CODE: return state.set("mode", Mode.SubmittingCode);
        case exports.SUBMIT_CODE_FAIL: return state.set("mode", Mode.EnteringCode);
        default: return state;
    }
}
exports.reducer = reducer;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__(24);
var Immutable = __webpack_require__(0);
var React = __webpack_require__(1);
var ReactRedux = __webpack_require__(2);
var Layout = __webpack_require__(22);
var Session = __webpack_require__(3);
var player_1 = __webpack_require__(25);
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.handleToggleMenu = _this.handleToggleMenu.bind(_this);
        return _this;
    }
    Component.prototype.myNextGame = function () {
        return this.props.activeGames && this.props.activeGames.find(function (g) {
            return g.game_player && g.game_player.is_turn || false;
        }) || undefined;
    };
    Component.prototype.render = function () {
        var _this = this;
        var title = "brdg.me";
        var myTurnGames = this.myTurnGames().size;
        if (myTurnGames > 0) {
            title += " (" + myTurnGames + ")";
        }
        var myNextGame = this.myNextGame();
        document.title = title;
        return (React.createElement("div", { className: "layout" },
            React.createElement("div", { className: classNames({
                    "layout-header": true,
                    "my-turn": myNextGame !== undefined,
                }) },
                React.createElement("input", { type: "button", onClick: this.handleToggleMenu, value: "Menu" }),
                React.createElement("span", { className: "header-title" }, "brdg.me"),
                this.props.onSubMenuButtonClick && React.createElement("input", { type: "button", onClick: this.props.onSubMenuButtonClick, value: "Sub menu" }),
                myNextGame && React.createElement("input", { type: "button", onClick: function () { return _this.props.onRedirect("/game/" + myNextGame.game.id); }, value: "Next game" })),
            React.createElement("div", { className: "layout-body" },
                React.createElement("div", { className: classNames({
                        menu: true,
                        open: this.props.menuOpen,
                    }) },
                    React.createElement("h1", null,
                        React.createElement("a", { onClick: function (e) {
                                e.preventDefault();
                                _this.props.onRedirect("/");
                                _this.props.onCloseMenu();
                            } }, "brdg.me")),
                    React.createElement("div", { className: "subheading" },
                        React.createElement("a", { onClick: function (e) {
                                e.preventDefault();
                                _this.props.onRedirect("/");
                                _this.props.onCloseMenu();
                            } }, "Lo-fi board games")),
                    this.renderAuth(),
                    React.createElement("div", null,
                        React.createElement("a", { onClick: function (e) {
                                e.preventDefault();
                                _this.props.onRedirect("/game/new");
                                _this.props.onCloseMenu();
                            } }, "New game")),
                    this.renderActiveGames()),
                React.createElement("div", { className: "content" }, this.props.children),
                this.props.menuOpen && React.createElement("div", { className: "menu-close-underlay", onClick: this.handleToggleMenu }))));
    };
    Component.prototype.renderGame = function (game) {
        var _this = this;
        var myPlayerId = game.game_player && game.game_player.id;
        return React.createElement("div", { className: classNames({
                "layout-game": true,
                "my-turn": game.game_player && game.game_player.is_turn,
                "finished": game.game_player && game.game.is_finished && !game.game_player.is_read,
            }) },
            React.createElement("a", { onClick: function (e) {
                    e.preventDefault();
                    _this.props.onRedirect("/game/" + game.game.id);
                    _this.props.onCloseMenu();
                } },
                React.createElement("div", { className: "layout-game-name" }, game.game_type.name),
                React.createElement("div", { className: "layout-game-opponents" },
                    "with ",
                    game.game_players
                        .filter(function (gp) { return gp && gp.game_player.id !== myPlayerId || false; })
                        .map(function (gp) { return React.createElement("span", null,
                        " ",
                        React.createElement(player_1.default, { name: gp.user.name, color: gp.game_player.color })); }))));
    };
    Component.prototype.renderActiveGames = function () {
        var _this = this;
        var activeGames = this.activeGames();
        if (activeGames.size === 0) {
            return undefined;
        }
        return React.createElement("div", null,
            React.createElement("h2", null, "Active games"),
            activeGames.map(function (g) { return g && _this.renderGame(g); }));
    };
    Component.prototype.activeGames = function () {
        if (this.props.activeGames === undefined || this.props.user === undefined) {
            return Immutable.List();
        }
        return this.props.activeGames
            .filter(function (ag) { return ag.game_player && (!ag.game.is_finished || !ag.game_player.is_read); })
            .sort(function (ag1, ag2) {
            // Finished games at the top.
            if (ag1.game.is_finished && !ag2.game.is_finished) {
                return -1;
            }
            if (ag2.game.is_finished && !ag1.game.is_finished) {
                return 1;
            }
            // Followed by current turn games, ordered by turn time.
            if (ag1.game_player.is_turn && ag2.game_player.is_turn) {
                if (ag1.game_player.is_turn_at < ag2.game_player.is_turn_at) {
                    return -1;
                }
                if (ag2.game_player.is_turn_at < ag1.game_player.is_turn_at) {
                    return 1;
                }
            }
            if (ag1.game_player.is_turn) {
                return -1;
            }
            if (ag2.game_player.is_turn) {
                return 1;
            }
            // Otherwise ordered by newest first.
            if (ag1.game.updated_at > ag2.game.updated_at) {
                return -1;
            }
            return 1;
        })
            .toList();
    };
    Component.prototype.myTurnGames = function () {
        if (this.props.activeGames === undefined || this.props.user === undefined) {
            return Immutable.List();
        }
        return this.props.activeGames
            .filter(function (ag) { return ag.game_player && ag.game_player.is_turn || false; })
            .sortBy(function (ag) { return ag.game_player.is_turn_at; })
            .toList();
    };
    Component.prototype.renderAuth = function () {
        var _this = this;
        if (this.props.user !== undefined) {
            return React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("a", { onClick: function (e) {
                            e.preventDefault();
                            _this.props.onLogout();
                        } }, "Logout")));
        }
        else {
            return React.createElement("div", null,
                React.createElement("a", { onClick: function (e) {
                        e.preventDefault();
                        _this.props.onRedirect("/login");
                    } }, "Log in"));
        }
    };
    Component.prototype.handleToggleMenu = function () {
        this.props.onToggleMenu();
    };
    return Component;
}(React.PureComponent));
exports.Component = Component;
function mapStateToProps(state, ownProps) {
    return {
        user: state.session.user,
        activeGames: state.game.games.size > 0 && state.game.games.toList() || undefined,
        menuOpen: state.layout.menuOpen,
        onSubMenuButtonClick: ownProps.onSubMenuButtonClick,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onLogout: function () { return dispatch(Session.clearToken()); },
        onRedirect: function (path) { return dispatch(Session.updatePath(path)); },
        onToggleMenu: function () { return dispatch(Layout.toggleMenu()); },
        onCloseMenu: function () { return dispatch(Layout.closeMenu()); },
    };
}
exports.Container = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Component);


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = ReduxSaga;

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["l" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* unused harmony export isEnd */
/* unused harmony export emitter */
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* unused harmony export eventChannel */
/* unused harmony export stdChannel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(34);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var superagent = __webpack_require__(38);
function submitLoginEmail(email) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .post("/api/auth")
                    .set("Content-Type", "application/json")
                    .set("Accept", "application/json")
                    .send({ email: email })];
        });
    });
}
exports.submitLoginEmail = submitLoginEmail;
function submitLoginCode(email, code) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .post("/api/auth/confirm")
                    .set("Content-Type", "application/json")
                    .set("Accept", "application/json")
                    .send({ email: email, code: code })
                    .then(function (res) { return res.body; })];
        });
    });
}
exports.submitLoginCode = submitLoginCode;
function fetchActiveGames(token) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .get("/api/game/my_active")
                    .set("Authorization", "Bearer " + token)
                    .set("Content-Type", "application/json")
                    .set("Accept", "application/json")
                    .then(function (res) { return res.body.games; })];
        });
    });
}
exports.fetchActiveGames = fetchActiveGames;
function fetchGame(id, token) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .get("/api/game/" + id)
                    .set("Authorization", "Bearer " + token)
                    .set("Content-Type", "application/json")
                    .set("Accept", "application/json")
                    .then(function (res) { return res.body; })];
        });
    });
}
exports.fetchGame = fetchGame;
function submitGameCommand(id, command, token) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .post("/api/game/" + id + "/command")
                    .set("Authorization", "Bearer " + token)
                    .set("Content-Type", "application/json")
                    .set("Accept", "application/json")
                    .send({ command: command })
                    .then(function (res) { return res.body; })];
        });
    });
}
exports.submitGameCommand = submitGameCommand;
function submitMarkGameRead(id, token) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .post("/api/game/" + id + "/mark_read")
                    .set("Authorization", "Bearer " + token)
                    .set("Content-Type", "application/json")
                    .set("Accept", "application/json")
                    .send()
                    .then(function (res) { return res.body; })];
        });
    });
}
exports.submitMarkGameRead = submitMarkGameRead;
function submitGameConcede(id, token) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .post("/api/game/" + id + "/concede")
                    .set("Authorization", "Bearer " + token)
                    .set("Content-Type", "application/json")
                    .set("Accept", "application/json")
                    .send()
                    .then(function (res) { return res.body; })];
        });
    });
}
exports.submitGameConcede = submitGameConcede;
function submitUndo(id, token) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .post("/api/game/" + id + "/undo")
                    .set("Authorization", "Bearer " + token)
                    .set("Content-Type", "application/json")
                    .set("Accept", "application/json")
                    .send()
                    .then(function (res) { return res.body; })];
        });
    });
}
exports.submitUndo = submitUndo;
function submitRestart(id, token) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .post("/api/game/" + id + "/restart")
                    .set("Authorization", "Bearer " + token)
                    .set("Content-Type", "application/json")
                    .set("Accept", "application/json")
                    .send()
                    .then(function (res) { return res.body; })];
        });
    });
}
exports.submitRestart = submitRestart;
function fetchInit(token) {
    return __awaiter(this, void 0, void 0, function () {
        var req;
        return __generator(this, function (_a) {
            req = superagent
                .get("/api/init")
                .set("Content-Type", "application/json")
                .set("Accept", "application/json");
            if (token !== undefined) {
                req.set("Authorization", "Bearer " + token);
            }
            return [2 /*return*/, req.then(function (res) { return res.body; })];
        });
    });
}
exports.fetchInit = fetchInit;
function submitNewGame(gameVersionId, userIds, emails, token) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .post("/api/game")
                    .set("Authorization", "Bearer " + token)
                    .set("Content-Type", "application/json")
                    .set("Accept", "application/json")
                    .send({
                    game_version_id: gameVersionId,
                    opponent_emails: emails.toJS(),
                    opponent_ids: userIds.toJS(),
                })
                    .then(function (res) { return res.body; })];
        });
    });
}
exports.submitNewGame = submitNewGame;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(0);
var Mode;
(function (Mode) {
    Mode[Mode["FetchingGameVersionTypes"] = 0] = "FetchingGameVersionTypes";
    Mode[Mode["Editable"] = 1] = "Editable";
    Mode[Mode["Submitting"] = 2] = "Submitting";
})(Mode = exports.Mode || (exports.Mode = {}));
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return State;
}(Immutable.Record({
    mode: Mode.Editable,
    game_version_types: Immutable.List(),
    game_version_id: "",
    emails: Immutable.List(),
    user_ids: Immutable.List(),
})));
exports.State = State;
exports.UPDATE_MODE = "brdgme/pages/game-new/UPDATE_MODE";
exports.FETCH_GAME_VERSION_TYPES = "brdgme/pages/game-new/FETCH_GAME_VERSION_TYPES";
exports.UPDATE_GAME_VERSION_ID = "brdgme/pages/game-new/UPDATE_GAME_VERSION_ID";
exports.ADD_EMAIL = "brdgme/pages/game-new/ADD_EMAIL";
exports.REMOVE_EMAIL = "brdgme/pages/game-new/REMOVE_EMAIL";
exports.UPDATE_EMAIL = "brdgme/pages/game-new/UPDATE_EMAIL";
exports.ADD_USER_ID = "brdgme/pages/game-new/ADD_USER_ID";
exports.REMOVE_USER_ID = "brdgme/pages/game-new/REMOVE_USER_ID";
exports.UPDATE_USER_ID = "brdgme/pages/game-new/UPDATE_USER_ID";
exports.SUBMIT = "brdgme/pages/game-new/SUBMIT";
exports.SUBMIT_SUCCESS = "brdgme/pages/game-new/SUBMIT_SUCCESS";
exports.SUBMIT_FAIL = "brdgme/pages/game-new/SUBMIT_FAIL";
exports.updateMode = function (mode) { return ({
    type: exports.UPDATE_MODE,
    payload: mode,
}); };
exports.fetchGameVersionTypes = function () { return ({
    type: exports.FETCH_GAME_VERSION_TYPES,
}); };
exports.updateGameVersionId = function (game_version_id) { return ({
    type: exports.UPDATE_GAME_VERSION_ID,
    payload: game_version_id,
}); };
exports.addEmail = function () { return ({ type: exports.ADD_EMAIL }); };
exports.removeEmail = function (index) { return ({
    type: exports.REMOVE_EMAIL,
    payload: index,
}); };
exports.updateEmail = function (index, email) { return ({
    type: exports.UPDATE_EMAIL,
    payload: { index: index, email: email },
}); };
exports.addUserId = function () { return ({ type: exports.ADD_USER_ID }); };
exports.removeUserId = function (index) { return ({
    type: exports.REMOVE_USER_ID,
    payload: index,
}); };
exports.updateUserId = function (index, user_id) { return ({
    type: exports.UPDATE_USER_ID,
    payload: { index: index, user_id: user_id },
}); };
exports.submit = function (game_version_id, emails, user_ids) { return ({
    type: exports.SUBMIT,
    payload: { game_version_id: game_version_id, emails: emails, user_ids: user_ids },
}); };
exports.submitSuccess = function (game) { return ({
    type: exports.SUBMIT_SUCCESS,
    payload: game,
}); };
exports.submitFail = function (error) { return ({
    type: exports.SUBMIT_FAIL,
    payload: error,
}); };
function reducer(state, action) {
    if (state === void 0) { state = new State(); }
    switch (action.type) {
        case exports.UPDATE_MODE: return state.set("mode", action.payload);
        case exports.UPDATE_GAME_VERSION_ID: return state.set("game_version_id", action.payload);
        case exports.ADD_EMAIL: return state.update("emails", function (emails) { return emails.push(""); });
        case exports.REMOVE_EMAIL: return state.update("emails", function (emails) { return emails.delete(action.payload); });
        case exports.UPDATE_EMAIL: return state.update("emails", function (emails) { return emails.set(action.payload.index, action.payload.email); });
        case exports.ADD_USER_ID: return state.update("user_ids", function (user_ids) { return user_ids.push(""); });
        case exports.REMOVE_USER_ID: return state.update("user_ids", function (user_ids) { return user_ids.delete(action.payload); });
        case exports.UPDATE_USER_ID: return state.update("user_ids", function (user_ids) { return user_ids.set(action.payload.index, action.payload.user_id); });
        case exports.SUBMIT_FAIL:
            alert("Failed to create game: " + action.payload);
            return state;
        default: return state;
    }
}
exports.reducer = reducer;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(0);
var ConnectionState;
(function (ConnectionState) {
    ConnectionState[ConnectionState["Connecting"] = 0] = "Connecting";
    ConnectionState[ConnectionState["Connected"] = 1] = "Connected";
    ConnectionState[ConnectionState["WaitingForReconnect"] = 2] = "WaitingForReconnect";
})(ConnectionState = exports.ConnectionState || (exports.ConnectionState = {}));
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return State;
}(Immutable.Record({
    connectionState: ConnectionState.Connecting,
    secondsBeforeReconnect: undefined,
    subUser: undefined,
    subGame: undefined,
})));
exports.State = State;
exports.CONNECTED = "brdgme/ws/CONNECTED";
exports.CONNECTING = "brdgme/ws/CONNECTING";
exports.WAITING_FOR_RECONNECT = "brdgme/ws/WAITING_FOR_RECONNECT";
exports.SUBSCRIBE_USER = "brdgme/ws/SUBSCRIBE_USER";
exports.UNSUBSCRIBE_USER = "brdgme/ws/UNSUBSCRIBE_USER";
exports.SUBSCRIBE_GAME = "brdgme/ws/SUBSCRIBE_GAME";
exports.UNSUBSCRIBE_GAME = "brdgme/ws/UNSUBSCRIBE_GAME";
exports.connected = function () { return ({ type: exports.CONNECTED }); };
exports.connecting = function () { return ({ type: exports.CONNECTING }); };
exports.waitingForReconnect = function (waitSeconds) { return ({
    type: exports.WAITING_FOR_RECONNECT,
    payload: waitSeconds,
}); };
exports.subscribeUser = function (token) { return ({
    type: exports.SUBSCRIBE_USER,
    payload: token,
}); };
exports.unsubscribeUser = function () { return ({
    type: exports.UNSUBSCRIBE_USER,
}); };
exports.subscribeGame = function (id) { return ({
    type: exports.SUBSCRIBE_GAME,
    payload: id,
}); };
exports.unsubscribeGame = function () { return ({
    type: exports.UNSUBSCRIBE_GAME,
}); };
function reducer(state, action) {
    if (state === void 0) { state = new State(); }
    switch (action.type) {
        case exports.CONNECTING:
            return state.set("connectionState", ConnectionState.Connecting);
        case exports.CONNECTED:
            return state
                .set("connectionState", ConnectionState.Connected)
                .remove("secondsBeforeReconnect");
        case exports.WAITING_FOR_RECONNECT:
            return state
                .set("connectionState", ConnectionState.WaitingForReconnect)
                .set("secondsBeforeReconnect", action.payload);
        case exports.SUBSCRIBE_USER: return state.set("subUser", action.payload);
        case exports.UNSUBSCRIBE_USER: return state.remove("subUser");
        case exports.SUBSCRIBE_GAME: return state.set("subGame", action.payload);
        case exports.UNSUBSCRIBE_GAME: return state.remove("subGame");
        default: return state;
    }
}
exports.reducer = reducer;


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["k" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["m" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["m" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(0);
var redux_saga_1 = __webpack_require__(11);
var effects_1 = __webpack_require__(6);
var http = __webpack_require__(14);
var Records = __webpack_require__(8);
var App = __webpack_require__(19);
var Game = __webpack_require__(5);
var Login = __webpack_require__(9);
var Session = __webpack_require__(3);
exports.LS_AUTH_TOKEN_OFFSET = "token";
function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeEvery(Login.SUBMIT_CODE_SUCCESS, loginSuccess)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(Session.UPDATE_PATH, updatePath)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(Session.UPDATE_TOKEN, updateToken)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(Session.CLEAR_TOKEN, clearToken)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(hashchange)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.sagas = sagas;
function loginSuccess(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(Session.updateToken(action.payload))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(Session.updatePath("/"))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function updatePath(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(App.clearPageState())];
            case 1:
                _a.sent();
                window.location.hash = action.payload;
                return [2 /*return*/];
        }
    });
}
function updateToken(action) {
    var init;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                localStorage.setItem(exports.LS_AUTH_TOKEN_OFFSET, action.payload);
                return [4 /*yield*/, effects_1.call(http.fetchInit, action.payload)];
            case 1:
                init = _a.sent();
                return [4 /*yield*/, effects_1.put(Session.updateUser(Records.User.fromJS(init.user)))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(Session.updateGameVersionTypes(Immutable.List(init.game_version_types.map(Records.GameVersionType.fromJS))))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(Game.updateGames(Records.GameExtended.fromJSList(init.games)))];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function clearToken(action) {
    return __generator(this, function (_a) {
        localStorage.removeItem(exports.LS_AUTH_TOKEN_OFFSET);
        location.reload(true);
        return [2 /*return*/];
    });
}
function hashchange() {
    var chan, newPath;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(hashchangeChannel)];
            case 1:
                chan = _a.sent();
                _a.label = 2;
            case 2:
                if (false) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(chan)];
            case 3:
                newPath = _a.sent();
                return [4 /*yield*/, effects_1.put(Session.updatePath(newPath))];
            case 4:
                _a.sent();
                return [3 /*break*/, 2];
            case 5: return [2 /*return*/];
        }
    });
}
function hashchangeChannel() {
    return redux_saga_1.eventChannel(function (emitter) {
        var listener = function () { return emitter(location.hash.substr(1) || "/"); };
        window.addEventListener("hashchange", listener);
        window.addEventListener("popstate", listener);
        return function () {
            window.removeEventListener("hashchange", listener);
            window.removeEventListener("popstate", listener);
        };
    });
}
exports.hashchangeChannel = hashchangeChannel;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(0);
var redux_immutable_1 = __webpack_require__(20);
var Game = __webpack_require__(5);
var Layout = __webpack_require__(22);
var Pages = __webpack_require__(44);
var Session = __webpack_require__(3);
var WS = __webpack_require__(16);
exports.CLEAR_PAGE_STATE = "brdgme/CLEAR_PAGE_STATE";
exports.clearPageState = function () { return ({
    type: exports.CLEAR_PAGE_STATE,
}); };
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return State;
}(Immutable.Record({
    game: new Game.State(),
    layout: new Layout.State(),
    pages: new Pages.State(),
    session: new Session.State(),
    ws: new WS.State(),
})));
exports.State = State;
var childrenReducer = redux_immutable_1.combineReducers({
    game: Game.reducer,
    layout: Layout.reducer,
    pages: Pages.reducer,
    session: Session.reducer,
    ws: WS.reducer,
});
function reducer(state, action) {
    if (state === void 0) { state = new State(); }
    state = childrenReducer(state, action);
    switch (action.type) {
        case exports.CLEAR_PAGE_STATE: return state.remove("pages");
        default: return state;
    }
}
exports.reducer = reducer;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineReducers = undefined;

var _combineReducers2 = __webpack_require__(40);

var _combineReducers3 = _interopRequireDefault(_combineReducers2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.combineReducers = _combineReducers3.default;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (action) {
  return action && action.type === '@@redux/INIT' ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
};

module.exports = exports['default'];


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(0);
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return State;
}(Immutable.Record({
    menuOpen: false,
})));
exports.State = State;
exports.TOGGLE_MENU = "brdgme/layout/TOGGLE_MENU";
exports.CLOSE_MENU = "brdgme/layout/CLOSE_MENU";
exports.toggleMenu = function () { return ({
    type: exports.TOGGLE_MENU,
}); };
exports.closeMenu = function () { return ({
    type: exports.CLOSE_MENU,
}); };
function reducer(state, action) {
    if (state === void 0) { state = new State(); }
    switch (action.type) {
        case exports.TOGGLE_MENU: return state.update("menuOpen", function (menuOpen) { return !menuOpen; });
        case exports.CLOSE_MENU: return state.set("menuOpen", false);
        default: return state;
    }
}
exports.reducer = reducer;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(0);
var Game = __webpack_require__(5);
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return State;
}(Immutable.Record({
    command: "",
    commandPos: 0,
    commandFocused: false,
    submittingCommand: false,
    commandError: undefined,
    suggestions: Immutable.List(),
    allSuggestions: Immutable.List(),
    subMenuOpen: false,
})));
exports.State = State;
exports.UPDATE_COMMAND = "brdgme/pages/game-show/UPDATE_COMMAND";
exports.TOGGLE_SUB_MENU = "brdgme/pages/game-show/TOGGLE_SUB_MENU";
exports.COMMAND_FOCUS = "brdgme/pages/game-show/COMMAND_FOCUS";
exports.COMMAND_BLUR = "brdgme/pages/game-show/COMMAND_BLUR";
exports.updateCommand = function (command, commandPos, commandSpec) { return ({
    type: exports.UPDATE_COMMAND,
    payload: { command: command, commandPos: commandPos, commandSpec: commandSpec },
}); };
exports.toggleSubMenu = function () { return ({ type: exports.TOGGLE_SUB_MENU }); };
exports.commandFocus = function () { return ({ type: exports.COMMAND_FOCUS }); };
exports.commandBlur = function () { return ({ type: exports.COMMAND_BLUR }); };
function reducer(state, action) {
    if (state === void 0) { state = new State(); }
    switch (action.type) {
        case exports.UPDATE_COMMAND: return state
            .set("command", action.payload.command)
            .set("commandPos", action.payload.commandPos);
        case exports.COMMAND_FOCUS: return state.set("commandFocused", true);
        case exports.COMMAND_BLUR: return state.set("commandFocused", false);
        case exports.TOGGLE_SUB_MENU: return state.update("subMenuOpen", function (s) { return !s; });
        case Game.SUBMIT_COMMAND:
        case Game.SUBMIT_UNDO:
            return state.set("submittingCommand", true);
        case Game.SUBMIT_COMMAND_SUCCESS:
        case Game.SUBMIT_UNDO_SUCCESS:
            return state
                .set("submittingCommand", false)
                .set("command", "")
                .set("commandPos", 0)
                .remove("commandError");
        case Game.SUBMIT_COMMAND_FAIL: return state
            .set("commandError", action.payload)
            .set("submittingCommand", false);
        case Game.SUBMIT_UNDO_FAIL: return state
            .set("submittingCommand", false);
        default: return state;
    }
}
exports.reducer = reducer;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = classNames;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(1);
var camelRegex = /([A-Z])/g;
function camelToKebab(s) {
    if (s.length === 0) {
        return s;
    }
    return s.substr(0, 1).toLowerCase() +
        s.substr(1).replace(camelRegex, function (_, b) { return "-" + b.toLowerCase(); });
}
var Player = /** @class */ (function (_super) {
    __extends(Player, _super);
    function Player() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Player.prototype.render = function () {
        return React.createElement("strong", { className: "brdgme-" + camelToKebab(this.props.color) },
            "<",
            this.props.name,
            ">");
    };
    return Player;
}(React.PureComponent));
exports.default = Player;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(1);
var Spinner = /** @class */ (function (_super) {
    __extends(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.render = function () {
        return React.createElement("div", { className: "spinner" },
            React.createElement("div", { className: "bounce1" }),
            React.createElement("div", { className: "bounce2" }),
            React.createElement("div", { className: "bounce3" }));
    };
    return Spinner;
}(React.Component));
exports.Spinner = Spinner;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(28);
var ReactRedux = __webpack_require__(2);
var Redux = __webpack_require__(29);
var redux_saga_1 = __webpack_require__(11);
var Session = __webpack_require__(3);
var sagas_1 = __webpack_require__(30);
var session_1 = __webpack_require__(18);
__webpack_require__(46); // tslint:disable-line
var app_1 = __webpack_require__(47);
var reducers_1 = __webpack_require__(19);
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || Redux.compose;
// Create store and initialise path and token.
var sagaMiddleware = redux_saga_1.default();
var store = Redux.createStore(reducers_1.reducer, new reducers_1.State(), composeEnhancers(Redux.applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(sagas_1.default);
store.dispatch(Session.updatePath(location.hash.substr(1)));
var token = localStorage.getItem(session_1.LS_AUTH_TOKEN_OFFSET);
if (token !== null) {
    store.dispatch(Session.updateToken(token));
}
ReactDOM.render(React.createElement(ReactRedux.Provider, { store: store },
    React.createElement(app_1.Container, null)), document.body);


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = Redux;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = __webpack_require__(6);
var game_1 = __webpack_require__(37);
var login_1 = __webpack_require__(39);
var session_1 = __webpack_require__(18);
var ws_1 = __webpack_require__(45);
function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, [
                    effects_1.fork(game_1.sagas),
                    effects_1.fork(login_1.sagas),
                    effects_1.fork(session_1.sagas),
                    effects_1.fork(ws_1.sagas),
                ]];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.default = sagas;


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony export (immutable) */ __webpack_exports__["b"] = takeLatest;
/* harmony export (immutable) */ __webpack_exports__["c"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__io__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(32);



function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["i" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["i" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["i" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["g" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["g" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["g" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(13);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["q" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["i" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* unused harmony export suspend */
/* unused harmony export flush */
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(13);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["q" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["i" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["q" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["i" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(0);
var effects_1 = __webpack_require__(6);
var http = __webpack_require__(14);
var Records = __webpack_require__(8);
var Game = __webpack_require__(5);
var GameNew = __webpack_require__(15);
var Session = __webpack_require__(3);
function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeEvery(Game.FETCH_GAME, fetchGame)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(Game.SUBMIT_COMMAND, submitCommand)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(Game.SUBMIT_UNDO, submitUndo)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(Game.SUBMIT_RESTART, submitRestart)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(Game.SUBMIT_MARK_READ, submitMarkRead)];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(Game.SUBMIT_CONCEDE, submitConcede)];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(GameNew.SUBMIT, submitNewGame)];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.sagas = sagas;
function fetchGame(action) {
    var token, game, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(function (state) { return state.session.token; })];
            case 1:
                token = _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, , 7]);
                return [4 /*yield*/, effects_1.call(http.fetchGame, action.payload, token)];
            case 3:
                game = _a.sent();
                return [4 /*yield*/, effects_1.put(Game.fetchGameSuccess(game))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                e_1 = _a.sent();
                return [4 /*yield*/, effects_1.put(Game.fetchGameFail())];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function submitCommand(action) {
    var token, game, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(function (state) { return state.session.token; })];
            case 1:
                token = _a.sent();
                if (token === undefined) {
                    return [2 /*return*/];
                }
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, , 7]);
                return [4 /*yield*/, effects_1.call(http.submitGameCommand, action.payload.gameId, action.payload.command, token)];
            case 3:
                game = _a.sent();
                return [4 /*yield*/, effects_1.put(Game.submitCommandSuccess(game))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                e_2 = _a.sent();
                return [4 /*yield*/, effects_1.put(Game.submitCommandFail(e_2.response && e_2.response.text || e_2.message))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function submitUndo(action) {
    var token, game, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(function (state) { return state.session.token; })];
            case 1:
                token = _a.sent();
                if (token === undefined) {
                    return [2 /*return*/];
                }
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, , 7]);
                return [4 /*yield*/, effects_1.call(http.submitUndo, action.payload, token)];
            case 3:
                game = _a.sent();
                return [4 /*yield*/, effects_1.put(Game.submitUndoSuccess(game))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                e_3 = _a.sent();
                return [4 /*yield*/, effects_1.put(Game.submitUndoFail(e_3.response && e_3.response.text || e_3.message))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function submitRestart(action) {
    var token, game, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(function (state) { return state.session.token; })];
            case 1:
                token = _a.sent();
                if (token === undefined) {
                    return [2 /*return*/];
                }
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 8]);
                return [4 /*yield*/, effects_1.call(http.submitRestart, action.payload, token)];
            case 3:
                game = _a.sent();
                return [4 /*yield*/, effects_1.put(Game.submitRestartSuccess(action.payload, game))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(Session.updatePath("/game/" + game.game.id))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                e_4 = _a.sent();
                return [4 /*yield*/, effects_1.put(Game.submitRestartFail(e_4.response && e_4.response.text || e_4.message))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function submitMarkRead(action) {
    var token, gamePlayer, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(function (state) { return state.session.token; })];
            case 1:
                token = _a.sent();
                if (token === undefined) {
                    return [2 /*return*/];
                }
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, , 7]);
                return [4 /*yield*/, effects_1.call(http.submitMarkGameRead, action.payload, token)];
            case 3:
                gamePlayer = _a.sent();
                return [4 /*yield*/, effects_1.put(Game.submitMarkReadSuccess(gamePlayer))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                e_5 = _a.sent();
                return [4 /*yield*/, effects_1.put(Game.submitMarkReadFail(e_5.response && e_5.response.text || e_5.message))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function submitConcede(action) {
    var token, game, e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(function (state) { return state.session.token; })];
            case 1:
                token = _a.sent();
                if (token === undefined) {
                    return [2 /*return*/];
                }
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, , 7]);
                return [4 /*yield*/, effects_1.call(http.submitGameConcede, action.payload, token)];
            case 3:
                game = _a.sent();
                return [4 /*yield*/, effects_1.put(Game.submitConcedeSuccess(game))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                e_6 = _a.sent();
                return [4 /*yield*/, effects_1.put(Game.submitConcedeFail(e_6.response && e_6.response.text || e_6.message))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function submitNewGame(action) {
    var token, game, _a, _b, e_7;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, effects_1.select(function (state) { return state.session.token; })];
            case 1:
                token = _c.sent();
                if (token === undefined) {
                    return [2 /*return*/];
                }
                _c.label = 2;
            case 2:
                _c.trys.push([2, 7, , 9]);
                _b = (_a = Records.GameExtended).fromJS;
                return [4 /*yield*/, effects_1.call(http.submitNewGame, action.payload.game_version_id, action.payload.emails, action.payload.user_ids, token)];
            case 3:
                game = _b.apply(_a, [_c.sent()]);
                return [4 /*yield*/, effects_1.put(Game.updateGames(Immutable.List([game])))];
            case 4:
                _c.sent();
                return [4 /*yield*/, effects_1.put(Session.updatePath("/game/" + game.game.id))];
            case 5:
                _c.sent();
                return [4 /*yield*/, effects_1.put(GameNew.submitSuccess(game))];
            case 6:
                _c.sent();
                return [3 /*break*/, 9];
            case 7:
                e_7 = _c.sent();
                return [4 /*yield*/, effects_1.put(GameNew.submitFail(e_7.response && e_7.response.text || e_7.message))];
            case 8:
                _c.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}


/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = superagent;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = __webpack_require__(6);
var http = __webpack_require__(14);
var Login = __webpack_require__(9);
function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeEvery(Login.SUBMIT_EMAIL, submitLoginEmail)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(Login.SUBMIT_CODE, submitLoginCode)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.sagas = sagas;
function submitLoginEmail(action) {
    var e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, effects_1.call(http.submitLoginEmail, action.payload || "")];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(Login.submitEmailSuccess())];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _a.sent();
                return [4 /*yield*/, effects_1.put(Login.submitEmailFail())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function submitLoginCode(action) {
    var token, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, effects_1.call(http.submitLoginCode, action.payload.email, action.payload.code)];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, effects_1.put(Login.submitCodeSuccess(token))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_2 = _a.sent();
                return [4 /*yield*/, effects_1.put(Login.submitCodeFail())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(0);

var _immutable2 = _interopRequireDefault(_immutable);

var _utilities = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (reducers) {
  var getDefaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _immutable2.default.Map;

  var reducerKeys = Object.keys(reducers);

  // eslint-disable-next-line space-infix-ops
  return function () {
    var inputState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
    var action = arguments[1];

    // eslint-disable-next-line no-process-env
    if (false) {
      var warningMessage = (0, _utilities.getUnexpectedInvocationParameterMessage)(inputState, reducers, action);

      if (warningMessage) {
        // eslint-disable-next-line no-console
        console.error(warningMessage);
      }
    }

    return inputState.withMutations(function (temporaryState) {
      reducerKeys.forEach(function (reducerName) {
        var reducer = reducers[reducerName];
        var currentDomainState = temporaryState.get(reducerName);
        var nextDomainState = reducer(currentDomainState, action);

        (0, _utilities.validateNextState)(nextDomainState, reducerName, action);

        temporaryState.set(reducerName, nextDomainState);
      });
    });
  };
};

module.exports = exports['default'];


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateNextState = exports.getUnexpectedInvocationParameterMessage = exports.getStateName = undefined;

var _getStateName2 = __webpack_require__(21);

var _getStateName3 = _interopRequireDefault(_getStateName2);

var _getUnexpectedInvocationParameterMessage2 = __webpack_require__(42);

var _getUnexpectedInvocationParameterMessage3 = _interopRequireDefault(_getUnexpectedInvocationParameterMessage2);

var _validateNextState2 = __webpack_require__(43);

var _validateNextState3 = _interopRequireDefault(_validateNextState2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.getStateName = _getStateName3.default;
exports.getUnexpectedInvocationParameterMessage = _getUnexpectedInvocationParameterMessage3.default;
exports.validateNextState = _validateNextState3.default;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(0);

var _immutable2 = _interopRequireDefault(_immutable);

var _getStateName = __webpack_require__(21);

var _getStateName2 = _interopRequireDefault(_getStateName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (state, reducers, action) {
  var reducerNames = Object.keys(reducers);

  if (!reducerNames.length) {
    return 'Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.';
  }

  var stateName = (0, _getStateName2.default)(action);

  if (_immutable2.default.isImmutable ? !_immutable2.default.isImmutable(state) : !_immutable2.default.Iterable.isIterable(state)) {
    return 'The ' + stateName + ' is of unexpected type. Expected argument to be an instance of Immutable.Collection or Immutable.Record with the following properties: "' + reducerNames.join('", "') + '".';
  }

  var unexpectedStatePropertyNames = state.toSeq().keySeq().toArray().filter(function (name) {
    return !reducers.hasOwnProperty(name);
  });

  if (unexpectedStatePropertyNames.length > 0) {
    return 'Unexpected ' + (unexpectedStatePropertyNames.length === 1 ? 'property' : 'properties') + ' "' + unexpectedStatePropertyNames.join('", "') + '" found in ' + stateName + '. Expected to find one of the known reducer property names instead: "' + reducerNames.join('", "') + '". Unexpected properties will be ignored.';
  }

  return null;
};

module.exports = exports['default'];


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (nextState, reducerName, action) {
  // eslint-disable-next-line no-undefined
  if (nextState === undefined) {
    throw new Error('Reducer "' + reducerName + '" returned undefined when handling "' + action.type + '" action. To ignore an action, you must explicitly return the previous state.');
  }
};

module.exports = exports['default'];


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(0);
var redux_immutable_1 = __webpack_require__(20);
var GameNew = __webpack_require__(15);
var GameShow = __webpack_require__(23);
var Login = __webpack_require__(9);
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return State;
}(Immutable.Record({
    gameNew: new GameNew.State(),
    gameShow: new GameShow.State(),
    login: new Login.State(),
})));
exports.State = State;
exports.reducer = redux_immutable_1.combineReducers({
    gameNew: GameNew.reducer,
    gameShow: GameShow.reducer,
    login: Login.reducer,
});


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_saga_1 = __webpack_require__(11);
var effects_1 = __webpack_require__(6);
var Records = __webpack_require__(8);
var Game = __webpack_require__(5);
var Session = __webpack_require__(3);
var WS = __webpack_require__(16);
exports.LS_AUTH_TOKEN_OFFSET = "token";
function sleep(ms) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
        });
    });
}
function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.fork(wsSaga)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(Session.UPDATE_TOKEN, updateToken)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(Session.CLEAR_TOKEN, clearToken)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.sagas = sagas;
function updateToken(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(WS.subscribeUser(action.payload))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.updateToken = updateToken;
function clearToken(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(WS.unsubscribeUser())];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.clearToken = clearToken;
function wsSaga() {
    var actions, socket, socketClose, s, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.actionChannel([
                    WS.SUBSCRIBE_GAME,
                    WS.UNSUBSCRIBE_GAME,
                    WS.SUBSCRIBE_USER,
                    WS.UNSUBSCRIBE_USER,
                ])];
            case 1:
                actions = _a.sent();
                _a.label = 2;
            case 2:
                if (false) return [3 /*break*/, 13];
                _a.label = 3;
            case 3:
                _a.trys.push([3, , 9, 12]);
                return [4 /*yield*/, effects_1.call(connect, "ws://" + window.location.host + "/ws")];
            case 4:
                socket = _a.sent();
                socketClose = effects_1.call(socketClosePromise, socket);
                return [4 /*yield*/, effects_1.fork(socketSagas, socket)];
            case 5:
                s = _a.sent();
                _a.label = 6;
            case 6:
                if (false) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.race({
                        action: effects_1.take(actions),
                        close: socketClose,
                    })];
            case 7:
                action = (_a.sent()).action;
                if (action) {
                    sendAction(socket, action);
                }
                else {
                    return [3 /*break*/, 8];
                }
                return [3 /*break*/, 6];
            case 8: return [3 /*break*/, 12];
            case 9: return [4 /*yield*/, effects_1.put(WS.waitingForReconnect(5))];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.call(sleep, 5 * 1000)];
            case 11:
                _a.sent();
                return [7 /*endfinally*/];
            case 12: return [3 /*break*/, 2];
            case 13: return [2 /*return*/];
        }
    });
}
exports.wsSaga = wsSaga;
function socketClosePromise(socket) {
    return new Promise(function (resolve, reject) {
        return socket.addEventListener("close", function () { return resolve(); });
    });
}
function handleMessages(socket) {
    var chan, message, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(messageChannel, socket)];
            case 1:
                chan = _a.sent();
                _a.label = 2;
            case 2:
                if (false) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(chan)];
            case 3:
                message = _a.sent();
                data = JSON.parse(message.data);
                if (!data.GameUpdate) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(Game.updateGames(Records.GameExtended.fromJSList([
                        data.GameUpdate,
                    ])))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                if (!data.GameRestarted) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(Game.gameRestarted(data.GameRestarted.game_id, data.GameRestarted.restarted_game_id))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 2];
            case 8: return [2 /*return*/];
        }
    });
}
exports.handleMessages = handleMessages;
function messageChannel(socket) {
    return redux_saga_1.eventChannel(function (emitter) {
        var listener = function (event) {
            emitter(event);
        };
        socket.addEventListener("message", listener);
        socket.addEventListener("close", function () { return emitter(redux_saga_1.END); });
        return function () {
            socket.removeEventListener("message", listener);
        };
    });
}
exports.messageChannel = messageChannel;
function connect(addr) {
    return new Promise(function (resolve, reject) {
        var socket = new WebSocket(addr);
        socket.addEventListener("open", function (event) { return resolve(socket); });
        socket.addEventListener("error", function (event) { return reject(event); });
    });
}
function socketSagas(socket) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.fork(handleMessages, socket)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function sendAction(socket, action) {
    socket.send(JSON.stringify(action));
}


/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(1);
var ReactRedux = __webpack_require__(2);
var Router = __webpack_require__(48);
var index_1 = __webpack_require__(49);
var new_1 = __webpack_require__(50);
var show_1 = __webpack_require__(51);
var home_1 = __webpack_require__(54);
var login_1 = __webpack_require__(55);
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Component.prototype.render = function () {
        return Router.first(this.props.path, [
            Router.match("/login", function () { return React.createElement(login_1.Container, null); }),
            Router.prefix("/game", function (remaining) {
                return Router.first(remaining, [
                    Router.match("/new", function () { return React.createElement(new_1.Container, null); }),
                    Router.empty(function () { return React.createElement(index_1.GameIndex, null); }),
                    Router.any(function () { return React.createElement(show_1.Container, { gameId: remaining.substr(1) }); }),
                ]);
            }),
            Router.any(function () { return React.createElement(home_1.Container, null); }),
        ]) || React.createElement("div", null);
    };
    return Component;
}(React.PureComponent));
exports.Component = Component;
function mapStateToProps(state) {
    return {
        path: state.session.path,
    };
}
function mapDispatchToProps(dispatch) {
    return {};
}
exports.Container = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Component);


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function first(input, handlers) {
    for (var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++) {
        var h = handlers_1[_i];
        var res = h(input);
        if (res !== undefined) {
            return res;
        }
    }
    return undefined;
}
exports.first = first;
function prefix(p, success) {
    return function (input) {
        if (input.substr(0, p.length) === p) {
            return success(input.substr(p.length));
        }
        return undefined;
    };
}
exports.prefix = prefix;
function match(p, success) {
    return function (input) {
        if (input === p) {
            return success();
        }
        return undefined;
    };
}
exports.match = match;
function empty(success) {
    return match("", success);
}
exports.empty = empty;
function any(success) {
    return function (input) { return success(); };
}
exports.any = any;
var intRegex = /^-?[0-9]+/;
function int(success) {
    return function (input) {
        var res = intRegex.exec(input);
        if (!res) {
            return undefined;
        }
        return success(parseInt(res[0], 10), input.substr(res[0].length));
    };
}
exports.int = int;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(1);
var layout_1 = __webpack_require__(10);
var GameIndex = /** @class */ (function (_super) {
    __extends(GameIndex, _super);
    function GameIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameIndex.prototype.render = function () {
        return (React.createElement(layout_1.Container, null,
            React.createElement("h1", null, "Game index")));
    };
    return GameIndex;
}(React.Component));
exports.GameIndex = GameIndex;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(0);
var React = __webpack_require__(1);
var ReactRedux = __webpack_require__(2);
var GameNew = __webpack_require__(15);
var layout_1 = __webpack_require__(10);
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleGameVersionSelectChange = _this.handleGameVersionSelectChange.bind(_this);
        _this.handleAddUserIdClick = _this.handleAddUserIdClick.bind(_this);
        _this.handleAddEmailClick = _this.handleAddEmailClick.bind(_this);
        return _this;
    }
    Component.prototype.render = function () {
        var _this = this;
        return (React.createElement(layout_1.Container, null,
            React.createElement("h1", null, "New game"),
            React.createElement("form", { onSubmit: this.handleSubmit },
                React.createElement("h2", null, "Game"),
                React.createElement("div", null,
                    React.createElement("select", { value: this.props.gameVersionId, onChange: this.handleGameVersionSelectChange },
                        React.createElement("option", null, "Choose game"),
                        this.props.gameVersionTypes.map(function (gv) { return React.createElement("option", { value: gv.game_version.id }, gv.game_type.name); }))),
                React.createElement("div", { style: {
                        display: "none",
                    } },
                    React.createElement("h2", null, "Opponent IDs"),
                    this.props.userIds.map(function (uId, key) { return React.createElement("div", null,
                        React.createElement("input", { value: uId, onChange: function (e) { return _this.handleUserIdChange(e, key); } }),
                        React.createElement("a", { onClick: function (e) { return _this.handleRemoveUserId(e, key); } }, "X")); })),
                React.createElement("div", null,
                    React.createElement("a", { onClick: this.handleAddUserIdClick }, "Add")),
                React.createElement("h2", null, "Opponent emails"),
                this.props.emails.map(function (email, key) { return React.createElement("div", null,
                    React.createElement("input", { value: email, onChange: function (e) { return _this.handleEmailChange(e, key); } }),
                    React.createElement("a", { onClick: function (e) { return _this.handleRemoveEmail(e, key); } }, "X")); }),
                React.createElement("div", null,
                    React.createElement("a", { onClick: this.handleAddEmailClick }, "Add")),
                React.createElement("div", null,
                    React.createElement("input", { type: "submit", value: "Create game" })))));
    };
    Component.prototype.handleSubmit = function (e) {
        e.preventDefault();
        if (this.props.gameVersionId === undefined) {
            return;
        }
        this.props.onSubmit(this.props.gameVersionId, this.props.userIds, this.props.emails);
    };
    Component.prototype.handleGameVersionSelectChange = function (e) {
        this.props.onUpdateGameVersionId(e.currentTarget.value);
    };
    Component.prototype.handleAddUserIdClick = function (e) {
        e.preventDefault();
        this.props.onAddUserId();
    };
    Component.prototype.handleRemoveUserId = function (e, key) {
        e.preventDefault();
        this.props.onRemoveUserId(key);
    };
    Component.prototype.handleUserIdChange = function (e, key) {
        this.props.onUpdateUserId(key, e.currentTarget.value);
    };
    Component.prototype.handleAddEmailClick = function (e) {
        e.preventDefault();
        this.props.onAddEmail();
    };
    Component.prototype.handleRemoveEmail = function (e, key) {
        e.preventDefault();
        this.props.onRemoveEmail(key);
    };
    Component.prototype.handleEmailChange = function (e, key) {
        e.preventDefault();
        this.props.onUpdateEmail(key, e.currentTarget.value);
    };
    return Component;
}(React.PureComponent));
exports.Component = Component;
function mapStateToProps(state, ownProps) {
    return {
        gameVersionTypes: state.session.gameVersionTypes || Immutable.List(),
        gameVersionId: state.pages.gameNew.game_version_id,
        userIds: state.pages.gameNew.user_ids,
        emails: state.pages.gameNew.emails,
        isSubmitting: state.pages.gameNew.mode === GameNew.Mode.Submitting,
    };
}
function mapDispatchToProps(dispatch, ownProps) {
    return {
        onUpdateGameVersionId: function (gameVersionId) { return dispatch(GameNew.updateGameVersionId(gameVersionId)); },
        onAddUserId: function () { return dispatch(GameNew.addUserId()); },
        onUpdateUserId: function (index, userId) { return dispatch(GameNew.updateUserId(index, userId)); },
        onRemoveUserId: function (index) { return dispatch(GameNew.removeUserId(index)); },
        onAddEmail: function () { return dispatch(GameNew.addEmail()); },
        onUpdateEmail: function (index, email) { return dispatch(GameNew.updateEmail(index, email)); },
        onRemoveEmail: function (index) { return dispatch(GameNew.removeEmail(index)); },
        onSubmit: function (gameVersionId, userIds, emails) {
            return dispatch(GameNew.submit(gameVersionId, userIds, emails));
        },
    };
}
exports.Container = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Component);


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__(24);
var Immutable = __webpack_require__(0);
var moment = __webpack_require__(52);
var React = __webpack_require__(1);
var ReactRedux = __webpack_require__(2);
var Command = __webpack_require__(53);
var Game = __webpack_require__(5);
var GameShow = __webpack_require__(23);
var Session = __webpack_require__(3);
var WS = __webpack_require__(16);
var layout_1 = __webpack_require__(10);
var player_1 = __webpack_require__(25);
var spinner_1 = __webpack_require__(26);
var timeFormat = "h:mm A";
var dowFormat = "ddd";
var recentDateFormat = "MMM D";
var oldDateFormat = "YYYY-M-D";
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onCommandInputChange = _this.onCommandInputChange.bind(_this);
        _this.onCommandPositionChange = _this.onCommandPositionChange.bind(_this);
        _this.focusCommandInput = _this.focusCommandInput.bind(_this);
        _this.onCommandSubmit = _this.onCommandSubmit.bind(_this);
        _this.handleSubMenuButtonClick = _this.handleSubMenuButtonClick.bind(_this);
        _this.handleSuggestionsContainerClick = _this.handleSuggestionsContainerClick.bind(_this);
        _this.handleCommandFocus = _this.handleCommandFocus.bind(_this);
        _this.handleCommandBlur = _this.handleCommandBlur.bind(_this);
        _this.renderMetaPlayer = _this.renderMetaPlayer.bind(_this);
        return _this;
    }
    Component.prototype.render = function () {
        return (React.createElement(layout_1.Container, { onSubMenuButtonClick: this.handleSubMenuButtonClick },
            React.createElement("div", { className: "game-container" },
                React.createElement("div", { className: "game-main" },
                    React.createElement("div", { className: "game-render" }, this.props.game && this.props.game.html
                        && React.createElement("pre", { dangerouslySetInnerHTML: { __html: this.props.game.html } })
                        || React.createElement(spinner_1.Spinner, null)),
                    this.renderRecentLogs(),
                    this.renderSuggestionBox(),
                    !this.isMyTurn() && this.renderWhoseTurn(),
                    this.isMyTurn() && this.props.game && this.props.game.game_player && React.createElement("div", { className: classNames({
                            "disabled": this.props.submittingCommand,
                            "game-command-input": true,
                        }) },
                        this.props.commandError && React.createElement("div", { className: "command-error" }, this.props.commandError),
                        React.createElement("form", { onSubmit: this.onCommandSubmit },
                            React.createElement("input", { ref: "command", type: "text", value: this.props.command, onChange: this.onCommandInputChange, onClick: this.onCommandPositionChange, onKeyUp: this.onCommandPositionChange, onFocus: this.handleCommandFocus, onBlur: this.handleCommandBlur, placeholder: !this.commandInputDisabled() && "Enter command..." || undefined, disabled: this.commandInputDisabled(), autoComplete: "off", autoCorrect: "off", autoCapitalize: "off", spellCheck: false }),
                            React.createElement("input", { type: "submit", value: "Send", disabled: this.commandInputDisabled() })))),
                this.renderMeta()),
            this.props.subMenuOpen && React.createElement("div", { className: "game-meta-close-underlay", onClick: this.handleSubMenuButtonClick })));
    };
    Component.prototype.componentDidMount = function () {
        this.fetchGameIfRequired(this.props);
        this.scrollToLastLog();
        this.props.onMarkRead(this.props.gameId);
        document.addEventListener("keydown", this.focusCommandInput);
        this.props.onSubscribeUpdates(this.props.gameId);
    };
    Component.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.gameId !== nextProps.gameId) {
            this.props.onUnsubscribeUpdates(this.props.gameId);
            this.props.onSubscribeUpdates(nextProps.gameId);
            this.props.onMarkRead(nextProps.gameId);
        }
        this.fetchGameIfRequired(nextProps);
    };
    Component.prototype.componentDidUpdate = function (prevProps, prevState) {
        var prevLogLen = prevProps.game
            && prevProps.game.game_logs
            && prevProps.game.game_logs.size
            || 0;
        var nextLogLen = this.props.game
            && this.props.game.game_logs
            && this.props.game.game_logs.size
            || 0;
        if (nextLogLen > prevLogLen ||
            !prevProps.subMenuOpen && this.props.subMenuOpen) {
            // New logs, scroll to bottom.
            this.scrollToLastLog();
        }
    };
    Component.prototype.componentWillUnmount = function () {
        document.removeEventListener("keydown", this.focusCommandInput);
        this.props.onUnsubscribeUpdates(this.props.gameId);
    };
    Component.prototype.commandSuggestions = function () {
        if (this.props.game === undefined || !this.props.game.command_spec) {
            return [];
        }
        var commandSpec = this.props.game.command_spec.toJS();
        var names = this.props.game.game_players.map(function (gptu) { return gptu.user.name; }).toArray();
        var fullCommand = Command.parse(this.props.command, 0, commandSpec, names);
        var suggestions = Command.suggestions(fullCommand, this.props.commandPos);
        var allSuggestions = [];
        var start = Command.startOfMatch(fullCommand, this.props.commandPos);
        if (start === undefined) {
            // Use the end of the last match, or the start of the current word if
            // the last match ends at the end of the last word.
            var lastMatch = Command.lastMatch(fullCommand);
            if (!this.props.command.substr(lastMatch.offset, this.props.commandPos - lastMatch.offset).match(/\s/)) {
                start = lastMatch.offset;
            }
        }
        if (start !== undefined) {
            var upToStart = Command.parse(this.props.command.substr(0, start), 0, commandSpec, names);
            allSuggestions = Command.suggestions(upToStart, start);
        }
        return suggestions;
    };
    Component.prototype.renderRecentLogs = function () {
        var logs = this.recentLogs();
        if (logs.size === 0) {
            return undefined;
        }
        return React.createElement("div", { className: "recent-logs-container" },
            React.createElement("div", { className: "recent-logs-header" }, "Recent logs"),
            React.createElement("div", { ref: "recentLogs", className: "recent-logs" }, logs.map(function (l) { return React.createElement("div", { dangerouslySetInnerHTML: { __html: l.html } }); })));
    };
    Component.prototype.renderSuggestionBox = function () {
        var suggestions = this.commandSuggestions();
        if (suggestions.length === 0) {
            return undefined;
        }
        return React.createElement("div", { className: "suggestions-container", onClick: this.handleSuggestionsContainerClick },
            React.createElement("div", { className: "suggestions-content" }, this.renderSuggestions(suggestions)));
    };
    Component.prototype.renderSuggestionDoc = function (s) {
        // Render doc for a single command on one line.
        if (s.values.length === 1 && s.values[0].kind === Command.SUGGESTION_VALUE) {
            return React.createElement("div", { className: "suggestion-doc-item" },
                this.renderSuggestionValueLink(s.values[0]),
                s.desc && React.createElement("span", { className: "suggestion-doc-desc" },
                    " - ",
                    s.desc));
        }
        return React.createElement("div", { className: "suggestion-doc" },
            s.desc && React.createElement("div", { className: "suggestion-doc-header" }, s.desc && React.createElement("span", { className: "suggestion-doc-desc" }, s.desc)),
            React.createElement("div", { className: "suggestion-doc-values" }, this.renderSuggestions(s.values)));
    };
    Component.prototype.renderSuggestions = function (suggestions) {
        var _this = this;
        // If the command input isn't focused, show a one-liner suggestion summary.
        /*
        if (!this.props.commandFocused && this.props.command === "") {
          return this.renderSuggestionsSummary(suggestions);
        }
        */
        // Render suggestions on one line if they're all values.
        if (suggestions.find(function (s) { return s.kind === Command.SUGGESTION_DOC; }) === undefined) {
            var sLen_1 = suggestions.length;
            return React.createElement("div", null, suggestions.map(function (s, index) { return React.createElement("span", null,
                _this.renderSuggestionValueLink(s),
                index < sLen_1 - 1 && " "); }));
        }
        // Otherwise render suggestions on separate lines.
        return React.createElement("div", null, suggestions.map(function (s) {
            switch (s.kind) {
                case Command.SUGGESTION_VALUE:
                    return React.createElement("div", null, _this.renderSuggestionValueLink(s));
                case Command.SUGGESTION_DOC:
                    return _this.renderSuggestionDoc(s);
            }
        }));
    };
    Component.prototype.recentLogs = function () {
        if (!this.props.game || !this.props.game.game_logs || !this.props.game.game_player) {
            return Immutable.List();
        }
        var gp = this.props.game.game_player;
        return this.props.game.game_logs.filter(function (gl) { return gl.game_log.created_at >= gp.last_turn_at; });
    };
    Component.prototype.renderSuggestionsSummary = function (suggestions) {
        var values = Command.suggestionValues(suggestions);
        var vLen = values.length;
        if (vLen === 0) {
            return React.createElement("div", null);
        }
        return React.createElement("div", null,
            "You can ",
            values.map(function (v, index) { return React.createElement("span", null,
                React.createElement("strong", null, v),
                index < vLen - 2 && ", ",
                index === vLen - 2 && " or "); }));
    };
    Component.prototype.renderSuggestionValueLink = function (s) {
        var _this = this;
        return React.createElement("a", { onClick: function (e) {
                e.preventDefault();
                _this.onCommandChange(_this.props.command.substr(0, s.offset)
                    + s.value
                    + " "
                    + _this.props.command.substr(s.offset + (s.length || 0)), s.offset + s.value.length + 1);
            } }, s.value);
    };
    Component.prototype.commandInputDisabled = function () {
        if (this.props.submittingCommand) {
            return true;
        }
        if (this.props.game === undefined) {
            return true;
        }
        if (this.props.game.game.is_finished) {
            return true;
        }
        if (this.props.game.game_player === undefined
            || !this.props.game.game_player.is_turn) {
            return true;
        }
        return false;
    };
    Component.prototype.scrollToLastLog = function () {
        if (this.refs.gameLogs !== undefined) {
            var gameLogs = this.refs.gameLogs;
            gameLogs.scrollTop = gameLogs.scrollHeight;
        }
        if (this.refs.recentLogs !== undefined) {
            var recentLogs = this.refs.recentLogs;
            recentLogs.scrollTop = recentLogs.scrollHeight;
        }
    };
    Component.prototype.renderMeta = function () {
        var _this = this;
        return React.createElement("div", { className: classNames({
                "game-meta": true,
                "open": this.props.subMenuOpen,
            }) },
            React.createElement("div", { className: "game-meta-main" }, this.props.game && React.createElement("div", null,
                React.createElement("h2", null, this.props.game.game_type && this.props.game.game_type.name),
                this.props.game.game_players && this.props.game.game_players.map(this.renderMetaPlayer),
                this.props.game.game_player && React.createElement("div", null,
                    React.createElement("h3", null, "Actions"),
                    !this.props.game.game.is_finished && this.props.game.game_players.size <= 2 && React.createElement("div", null,
                        React.createElement("a", { onClick: function (e) {
                                e.preventDefault();
                                if (confirm("Are you sure you want to concede?")) {
                                    _this.props.onConcede(_this.props.gameId);
                                }
                            } }, "Concede")),
                    this.props.game.game_player.can_undo && React.createElement("div", null,
                        React.createElement("a", { onClick: function (e) {
                                e.preventDefault();
                                _this.props.onUndo(_this.props.gameId);
                            } }, "Undo")),
                    this.props.game.game.restarted_game_id && React.createElement("div", null,
                        React.createElement("a", { onClick: function (e) {
                                e.preventDefault();
                                _this.props.onRedirect("/game/" + _this.props.game.game.restarted_game_id);
                            } }, "Go to restarted game")),
                    this.props.game.game_player
                        && this.props.game.game.is_finished
                        && !this.props.game.game.restarted_game_id
                        && React.createElement("div", null,
                            React.createElement("a", { onClick: function (e) {
                                    e.preventDefault();
                                    _this.props.onRestart(_this.props.gameId);
                                } }, "Restart"))))),
            React.createElement("div", { className: "game-meta-logs" },
                React.createElement("h2", null, "Logs"),
                React.createElement("div", { className: "game-meta-logs-content", ref: "gameLogs" }, this.renderLogs())));
    };
    Component.prototype.renderMetaPlayer = function (gp) {
        return React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(player_1.default, { name: gp.user.name, color: gp.game_player.color })),
            React.createElement("div", { style: {
                    marginLeft: "1em",
                } },
                React.createElement("div", null,
                    React.createElement("abbr", { title: "ELO rating, new players start at 1200", style: {
                            cursor: "help",
                        } }, "Rating"),
                    ":\u00A0",
                    gp.game_type_user.rating,
                    typeof gp.game_player.rating_change === "number" &&
                        React.createElement("span", null,
                            " (",
                            this.renderRatingChange(gp.game_player.rating_change),
                            ")")),
                gp.game_player.points !== undefined && React.createElement("div", null,
                    "Points: ",
                    gp.game_player.points)));
    };
    Component.prototype.renderRatingChange = function (amount) {
        return React.createElement("span", { className: "rating-change" },
            this.renderRatingChangeIcon(amount),
            Math.abs(amount));
    };
    Component.prototype.renderRatingChangeIcon = function (amount) {
        if (amount > 0) {
            return React.createElement("span", { className: "rating-change-up" }, "\u2197");
        }
        else if (amount < 0) {
            return React.createElement("span", { className: "rating-change-down" }, "\u2198");
        }
        else {
            return React.createElement("span", { className: "rating-change-none" }, "-");
        }
    };
    Component.prototype.isMyTurn = function () {
        return this.props.game
            && this.props.game.game_player
            && this.props.game.game_player.is_turn
            || false;
    };
    Component.prototype.renderWhoseTurn = function () {
        if (this.props.game === undefined) {
            return [];
        }
        var isMyTurn = this.isMyTurn();
        var opponentWhoseTurn = this.opponentWhoseTurn();
        var content = [];
        if (isMyTurn) {
            content.push(React.createElement("strong", null, "Your turn!"));
        }
        if (opponentWhoseTurn.size > 0) {
            var opponents = opponentWhoseTurn.map(function (o) { return React.createElement("span", null,
                " ",
                React.createElement(player_1.default, { name: o.user.name, color: o.game_player.color })); });
            if (isMyTurn) {
                content.push(React.createElement("span", null,
                    " (also",
                    opponents,
                    ")"));
            }
            else {
                content.push(React.createElement("span", null,
                    "Waiting on",
                    opponents));
            }
        }
        return [React.createElement("div", { className: classNames({
                    "game-current-turn": true,
                    "my-turn": isMyTurn,
                }) }, content)];
    };
    Component.prototype.opponentWhoseTurn = function () {
        var _this = this;
        return (this.props.game
            && this.props.game.game_players.filter(function (gp) {
                if (gp === undefined) {
                    return false;
                }
                if (gp.game_player.is_turn === false) {
                    return false;
                }
                if (_this.props.game.game_player
                    && _this.props.game.game_player.id === gp.game_player.id) {
                    return false;
                }
                return true;
            })
            || Immutable.List());
    };
    Component.prototype.fetchGameIfRequired = function (props) {
        if (props.game === undefined || props.game.html === undefined) {
            props.onFetch(props.gameId);
        }
    };
    Component.prototype.onCommandSubmit = function (e) {
        e.preventDefault();
        this.props.onCommand(this.props.gameId, this.props.command.trim());
    };
    Component.prototype.focusCommandInput = function () {
        if (this.refs.command === undefined) {
            return;
        }
        this.refs.command.focus();
    };
    Component.prototype.formatLogTime = function (t) {
        var prefix = "";
        if (t.isBefore(moment().startOf("month").subtract(11, "months"))) {
            prefix = oldDateFormat + ", ";
        }
        else if (t.isBefore(moment().startOf("day").subtract(6, "days"))) {
            prefix = recentDateFormat + ", ";
        }
        else if (t.isBefore(moment().startOf("day"))) {
            prefix = dowFormat + ", ";
        }
        return t.local().format("" + prefix + timeFormat);
    };
    Component.prototype.renderLogs = function () {
        var _this = this;
        if (this.props.game === undefined || this.props.game.game_logs === undefined) {
            return React.createElement("div", null);
        }
        var logs = this.props.game.game_logs;
        var lastLog;
        var renderedLogs = logs.map(function (gl) {
            var timeEl = React.createElement("div", null);
            var logTime = moment.utc(gl.game_log.logged_at);
            if (lastLog === undefined || logTime.clone().subtract(10, "minutes").isAfter(lastLog)) {
                timeEl = (React.createElement("div", { className: "log-time" },
                    "- ",
                    _this.formatLogTime(logTime),
                    " -"));
            }
            lastLog = logTime;
            return (React.createElement("div", { className: "game-log-entry" },
                timeEl,
                React.createElement("div", { dangerouslySetInnerHTML: { __html: gl.html } })));
        }).toArray();
        return React.createElement("div", null, renderedLogs);
    };
    Component.prototype.commandSpec = function () {
        return this.props.game
            && this.props.game.command_spec
            || undefined;
    };
    Component.prototype.onCommandInputChange = function (e) {
        this.onCommandChange(e.currentTarget.value, e.currentTarget.selectionStart || 0);
    };
    Component.prototype.handleCommandFocus = function (e) {
        this.props.onCommandFocus();
        this.onCommandPositionChange(e);
    };
    Component.prototype.onCommandPositionChange = function (e) {
        this.onCommandChange(this.props.command, e.currentTarget.selectionStart || 0);
    };
    Component.prototype.onCommandChange = function (command, commandPos) {
        if (command !== this.props.command
            || commandPos !== this.props.commandPos) {
            this.props.onCommandChange(command, commandPos, this.commandSpec());
        }
    };
    Component.prototype.handleSubMenuButtonClick = function () {
        this.props.onToggleSubMenu();
    };
    Component.prototype.handleSuggestionsContainerClick = function () {
        // this.focusCommandInput();
    };
    Component.prototype.handleCommandBlur = function () {
        var _this = this;
        // We want this to happen after click.
        setTimeout(function () {
            // Sometimes it is refocused though, so check to be sure.
            if (_this.refs.command !== document.activeElement) {
                _this.props.onCommandBlur();
            }
        }, 100);
    };
    return Component;
}(React.PureComponent));
exports.Component = Component;
function mapStateToProps(state, ownProps) {
    return {
        gameId: ownProps.gameId,
        game: state.game.games.get(ownProps.gameId),
        command: state.pages.gameShow.command,
        commandFocused: state.pages.gameShow.commandFocused,
        commandPos: state.pages.gameShow.commandPos,
        submittingCommand: state.pages.gameShow.submittingCommand,
        commandError: state.pages.gameShow.commandError,
        subMenuOpen: state.pages.gameShow.subMenuOpen,
    };
}
function mapDispatchToProps(dispatch, ownProps) {
    return {
        onCommand: function (gameId, command) { return dispatch(Game.submitCommand(gameId, command)); },
        onCommandFocus: function () { return dispatch(GameShow.commandFocus()); },
        onCommandBlur: function () { return dispatch(GameShow.commandBlur()); },
        onCommandChange: function (command, commandPos, commandSpec) {
            return dispatch(GameShow.updateCommand(command, commandPos, commandSpec));
        },
        onToggleSubMenu: function () { return dispatch(GameShow.toggleSubMenu()); },
        onUndo: function (gameId) { return dispatch(Game.submitUndo(gameId)); },
        onRestart: function (gameId) { return dispatch(Game.submitRestart(gameId)); },
        onFetch: function (gameId) { return dispatch(Game.fetchGame(gameId)); },
        onSubscribeUpdates: function (gameId) { return dispatch(WS.subscribeGame(gameId)); },
        onUnsubscribeUpdates: function () { return dispatch(WS.unsubscribeGame()); },
        onMarkRead: function (gameId) { return dispatch(Game.submitMarkRead(gameId)); },
        onConcede: function (gameId) { return dispatch(Game.submitConcede(gameId)); },
        onRedirect: function (path) { return dispatch(Session.updatePath(path)); },
    };
}
exports.Container = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Component);


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = moment;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMAND_SPEC_PLAYER = "Player";
exports.COMMAND_SPEC_SPACE = "Space";
// Match kinds are ordered strings so that FULL > PARTIAL > ERROR
exports.MATCH_FULL = "2_MATCH_FULL";
exports.MATCH_PARTIAL = "1_MATCH_PARTIAL";
exports.MATCH_ERROR = "0_MATCH_ERROR";
/**
 * Generates some potential values for the int parser to use for suggestions.
 * @param min minimum value
 * @param max maximum value
 */
function potentialIntValues(min, max) {
    var start = min || 1;
    var end = max || (start + 4);
    var values = [];
    for (var i = start; i <= end; i++) {
        values.push(i);
    }
    return values;
}
var intRegex = /\-?\d+/;
function parseIntSpec(input, offset, min, max) {
    // First we see if we have an actual integer match.
    var intMatches = intRegex.exec(input.substr(offset));
    // We also do an enum match so we can provide suggestions.
    var enumValues = potentialIntValues(min, max)
        .map(function (i) { return i.toString(); })
        .filter(function (i) { return !intMatches || intMatches[0] !== i; });
    var enumResult = parseEnum(input, offset, enumValues, true);
    var intResult = {
        kind: exports.MATCH_PARTIAL,
        offset: offset,
    };
    if (intMatches) {
        var value = parseInt(intMatches[0], 10);
        if (min !== undefined && min !== null && value < min) {
            intResult = {
                kind: exports.MATCH_ERROR,
                offset: offset,
                message: value + " is less than the minimum " + min,
            };
        }
        else if (max !== undefined && max !== null && value > max) {
            intResult = {
                kind: exports.MATCH_ERROR,
                offset: offset,
                message: value + " is greater than the maximum " + max,
            };
        }
        else {
            intResult = {
                kind: exports.MATCH_FULL,
                offset: offset,
                length: intMatches[0].length,
                value: intMatches[0],
            };
        }
    }
    var next;
    if (intResult.kind !== exports.MATCH_FULL) {
        next = enumResult.next;
    }
    return {
        kind: intResult.kind,
        offset: offset,
        length: intResult.length,
        value: intResult.value,
        next: next,
    };
}
exports.parseIntSpec = parseIntSpec;
function commonPrefix(s1, s2) {
    var iterBound = Math.min(s1.length, s2.length);
    for (var i = 0; i < iterBound; i++) {
        if (s1.charAt(i) !== s2.charAt(i)) {
            return s1.substr(0, i);
        }
    }
    return s1.substr(0, iterBound);
}
exports.commonPrefix = commonPrefix;
function parseEnum(input, offset, values, exact) {
    var matches = [];
    var length = 0;
    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
        var v = values_1[_i];
        var result = parseToken(input, offset, v);
        if (result.kind !== exports.MATCH_ERROR) {
            var matchLen = result.length || 0;
            if (matchLen > length) {
                matches = [];
                length = matchLen;
            }
            if (matchLen === length) {
                matches.push(result);
            }
        }
    }
    if (matches.length === 0) {
        return {
            kind: exports.MATCH_ERROR,
            offset: offset,
            message: "input doesn't match any value in: " + values.join(", "),
        };
    }
    if (matches.length === 1 && (matches[0].length || 0) > 0) {
        return Object.assign({}, matches[0], {
            kind: (matches[0].kind === exports.MATCH_FULL || !exact) && exports.MATCH_FULL || exports.MATCH_PARTIAL,
        });
    }
    for (var _a = 0, matches_1 = matches; _a < matches_1.length; _a++) {
        var m = matches_1[_a];
        if (m.kind === exports.MATCH_FULL) {
            return m;
        }
    }
    // Because we have multiple partial matches, we return this as a zero
    // length full match with all the partial matches as children.
    return {
        kind: exports.MATCH_FULL,
        offset: offset,
        next: matches,
    };
}
exports.parseEnum = parseEnum;
function parseToken(input, offset, token) {
    if (offset >= input.length) {
        return {
            kind: exports.MATCH_PARTIAL,
            offset: offset,
            value: token,
        };
    }
    var tLen = token.length;
    if (tLen === 0) {
        return {
            kind: exports.MATCH_FULL,
            offset: offset,
            value: "",
        };
    }
    var prefix = commonPrefix(input.substr(offset, tLen).toLowerCase(), token.toLowerCase());
    var prefixLen = prefix.length;
    if (prefixLen === 0) {
        return {
            kind: exports.MATCH_ERROR,
            offset: offset,
            message: "'" + token + "' not found",
        };
    }
    return {
        kind: tLen === prefixLen && exports.MATCH_FULL || exports.MATCH_PARTIAL,
        offset: offset,
        length: prefixLen,
        value: token,
    };
}
exports.parseToken = parseToken;
var spaceRegex = /^\s+/;
function parseSpace(input, offset) {
    if (offset >= input.length) {
        return {
            kind: exports.MATCH_PARTIAL,
            offset: offset,
        };
    }
    var matches = spaceRegex.exec(input.substr(offset));
    if (matches) {
        return {
            kind: exports.MATCH_FULL,
            offset: offset,
            length: matches[0].length,
            value: input.slice(offset, offset + matches[0].length),
        };
    }
    return {
        kind: exports.MATCH_ERROR,
        offset: offset,
        message: "expected a space",
    };
}
exports.parseSpace = parseSpace;
function parseOneOf(input, offset, specs, names) {
    var success = 0;
    var results = specs.map(function (s) {
        var res = parse(input, offset, s, names);
        if (res.kind !== exports.MATCH_ERROR) {
            success++;
        }
        return res;
    });
    return {
        kind: exports.MATCH_FULL,
        offset: offset,
        next: results,
    };
}
exports.parseOneOf = parseOneOf;
function parseDoc(input, offset, name, spec, names, desc) {
    return {
        kind: exports.MATCH_FULL,
        offset: offset,
        name: name,
        desc: desc,
        next: [parse(input, offset, spec, names)],
    };
}
exports.parseDoc = parseDoc;
/**
 * Flattens a result into the best matching branch, as well as a combined
 * version of the best matching branch.
 */
function flattenResult(result) {
    if (result.kind !== exports.MATCH_FULL || result.next === undefined || result.next.length === 0) {
        return {
            flat: result,
            combined: result,
        };
    }
    var best;
    for (var _i = 0, _a = result.next; _i < _a.length; _i++) {
        var n = _a[_i];
        var nFlat = flattenResult(n);
        if (best === undefined
            || nFlat.combined.kind > best.combined.kind
            || (nFlat.combined.kind === best.combined.kind
                && (nFlat.combined.length || 0) > (best.combined.length || 0))) {
            best = nFlat;
        }
    }
    return {
        flat: Object.assign({}, result, {
            next: [best.flat],
        }),
        combined: Object.assign({}, result, best, {
            kind: best.combined.kind,
            offset: result.offset,
            length: (result.length || 0) + (best.combined.length || 0),
            value: (result.value || "") + (best.combined.value || ""),
        }),
    };
}
exports.flattenResult = flattenResult;
/**
 * Appends the result as leaves to every branch of the tree.
 */
function pushResult(result, to) {
    if (to.next === undefined || to.next.length === 0) {
        return Object.assign({}, to, {
            next: [result],
        });
    }
    return Object.assign({}, to, {
        next: to.next.map(function (n) { return pushResult(result, n); }),
    });
}
exports.pushResult = pushResult;
exports.SUGGESTION_DOC = "SUGGESTION_DOC";
exports.SUGGESTION_VALUE = "SUGGESTION_VALUE";
function suggestions(result, at) {
    var s = [];
    var nextValues = [];
    if (result.next !== undefined) {
        for (var _i = 0, _a = result.next; _i < _a.length; _i++) {
            var n = _a[_i];
            nextValues = nextValues.concat(suggestions(n, at));
        }
    }
    if (result.kind !== exports.MATCH_ERROR && nextValues.length === 0) {
        var offset = result.offset || 0;
        var length_1 = result.length || 0;
        if (result.value !== undefined && offset <= at && offset + length_1 >= at) {
            s.push({
                kind: exports.SUGGESTION_VALUE,
                offset: result.offset,
                length: result.length,
                value: result.value,
            });
        }
    }
    s = s.concat(nextValues);
    if (s.length > 0 && result.desc !== undefined) {
        // We only document values which have a matching offset as the result, so
        // split them here.
        var docS = [];
        var valueS = [];
        for (var _b = 0, s_1 = s; _b < s_1.length; _b++) {
            var v = s_1[_b];
            if (v.offset === result.offset) {
                docS.push(v);
            }
            else {
                valueS.push(v);
            }
        }
        var splitS = [];
        if (docS.length > 0) {
            splitS.push({
                kind: exports.SUGGESTION_DOC,
                offset: result.offset,
                length: result.length,
                desc: result.desc,
                values: docS,
            });
        }
        return splitS.concat(valueS);
    }
    return s;
}
exports.suggestions = suggestions;
function suggestionValues(ss) {
    var values = [];
    for (var _i = 0, ss_1 = ss; _i < ss_1.length; _i++) {
        var s = ss_1[_i];
        switch (s.kind) {
            case exports.SUGGESTION_VALUE:
                values.push(s.value);
                break;
            case exports.SUGGESTION_DOC:
                values = values.concat(suggestionValues(s.values));
                break;
        }
    }
    return values;
}
exports.suggestionValues = suggestionValues;
function startOfMatch(result, at) {
    if (at === 0) {
        return 0;
    }
    if (result.value !== undefined
        && (result.length || 0) > 0
        && result.offset <= at
        && result.offset + (result.length || 0) >= at) {
        return result.offset;
    }
    if (result.next !== undefined) {
        for (var _i = 0, _a = result.next; _i < _a.length; _i++) {
            var n = _a[_i];
            var ns = startOfMatch(n, at);
            if (ns !== undefined) {
                return ns;
            }
        }
    }
}
exports.startOfMatch = startOfMatch;
function lastMatch(result) {
    var last = result;
    var lastPos = result.offset + (result.length || 0);
    if (result.next !== undefined) {
        for (var _i = 0, _a = result.next; _i < _a.length; _i++) {
            var n = _a[_i];
            var nl = lastMatch(n);
            var nlPos = nl.offset + (nl.length || 0);
            if (nlPos > lastPos) {
                last = nl;
                lastPos = nlPos;
            }
        }
    }
    return last;
}
exports.lastMatch = lastMatch;
function parseChain(input, offset, specs, names) {
    var headSpec = specs[0];
    var tailSpecs = specs.slice(1);
    var result = parse(input, offset, headSpec, names);
    var flatResult = flattenResult(result);
    if (flatResult.combined.kind !== exports.MATCH_FULL || tailSpecs.length === 0) {
        // No full match on this link of the chain or end of the chain, exit here.
        return result;
    }
    var tailResult = parseChain(input, offset + (flatResult.combined.length || 0), tailSpecs, names);
    return pushResult(tailResult, flatResult.flat);
}
exports.parseChain = parseChain;
function parseMany(input, offset, spec, names, delim, min, max) {
    var result;
    var matches = 0;
    var offsetIter = offset;
    while (true) {
        if (result && delim) {
            var delimResult = parse(input, offsetIter, delim, names);
            result = pushResult(delimResult, result);
            var delimFlatResult = flattenResult(delimResult);
            if (delimFlatResult.combined.kind !== exports.MATCH_FULL) {
                return result;
            }
            offsetIter = delimResult.offset + (delimResult.length || 0);
        }
        var itemResult = parse(input, offsetIter, spec, names);
        var itemFlatResult = flattenResult(itemResult);
        if (itemFlatResult.combined.kind === exports.MATCH_FULL) {
            matches++;
        }
        if (!result) {
            // If we don't have a top level result yet, we just use this one.
            result = itemResult;
        }
        else {
            // Otherwise we only append if relevant.
            if (itemFlatResult.combined.kind === exports.MATCH_ERROR &&
                min !== undefined && matches < min) {
                // We didn't parse another and haven't met the minimum yet, so this is an
                // error.
                result = pushResult(itemResult, result);
                result.kind = exports.MATCH_ERROR;
                return result;
            }
            if (itemFlatResult.combined.kind !== exports.MATCH_ERROR) {
                result = pushResult(itemResult, result);
            }
        }
        if (itemFlatResult.combined.kind !== exports.MATCH_FULL ||
            max !== undefined && matches == max) {
            if (min !== undefined && matches < min) {
                result.kind = exports.MATCH_PARTIAL;
            }
            return result;
        }
        offsetIter = itemResult.offset + (itemResult.length || 0);
    }
}
exports.parseMany = parseMany;
function parseOpt(input, offset, spec, names) {
    var subResult = parse(input, offset, spec, names);
    if (subResult.kind == exports.MATCH_ERROR) {
        return {
            kind: exports.MATCH_FULL,
            offset: offset,
            length: 0,
            value: '',
        };
    }
    return subResult;
}
exports.parseOpt = parseOpt;
function parsePlayer(input, offset, names) {
    return parseEnum(input, offset, names, false);
}
exports.parsePlayer = parsePlayer;
function parse(input, offset, spec, names) {
    if (spec === exports.COMMAND_SPEC_PLAYER) {
        return parsePlayer(input, offset, names);
    }
    else if (spec === exports.COMMAND_SPEC_SPACE) {
        return parseSpace(input, offset);
    }
    else if (spec.Int !== undefined) {
        return parseIntSpec(input, offset, spec.Int.min, spec.Int.max);
    }
    else if (spec.Token !== undefined) {
        return parseToken(input, offset, spec.Token);
    }
    else if (spec.Enum !== undefined) {
        return parseEnum(input, offset, spec.Enum.values, spec.Enum.exact);
    }
    else if (spec.OneOf !== undefined) {
        return parseOneOf(input, offset, spec.OneOf, names);
    }
    else if (spec.Chain !== undefined) {
        return parseChain(input, offset, spec.Chain, names);
    }
    else if (spec.Many !== undefined) {
        return parseMany(input, offset, spec.Many.spec, names, spec.Many.delim, spec.Many.min, spec.Many.max);
    }
    else if (spec.Opt !== undefined) {
        return parseOpt(input, offset, spec.Opt, names);
    }
    else if (spec.Doc !== undefined) {
        return parseDoc(input, offset, spec.Doc.name, spec.Doc.spec, names, spec.Doc.desc);
    }
    return {
        kind: exports.MATCH_ERROR,
        offset: offset,
        message: "invalid command spec",
    };
}
exports.parse = parse;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(1);
var ReactRedux = __webpack_require__(2);
var layout_1 = __webpack_require__(10);
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Component.prototype.render = function () {
        return (React.createElement(layout_1.Container, null,
            React.createElement("h1", null, "Home blah")));
    };
    return Component;
}(React.PureComponent));
exports.Component = Component;
function mapStateToProps(state) {
    return {};
}
function mapDispatchToProps(dispatch) {
    return {};
}
exports.Container = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Component);


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(1);
var ReactRedux = __webpack_require__(2);
var LoginReducer = __webpack_require__(9);
var spinner_1 = __webpack_require__(26);
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.handleChangeCode = _this.handleChangeCode.bind(_this);
        _this.handleChangeEmail = _this.handleChangeEmail.bind(_this);
        _this.handleClickChangeEmail = _this.handleClickChangeEmail.bind(_this);
        _this.handleClickHaveCode = _this.handleClickHaveCode.bind(_this);
        _this.handleSubmitCode = _this.handleSubmitCode.bind(_this);
        _this.handleSubmitEmail = _this.handleSubmitEmail.bind(_this);
        return _this;
    }
    Component.prototype.render = function () {
        return (React.createElement("div", { className: "login" },
            React.createElement("h1", null, "brdg.me"),
            React.createElement("div", { className: "subtitle" }, "Lo-fi board games, email / web"),
            this.props.mode === LoginReducer.Mode.EnteringEmail && (React.createElement("div", null,
                React.createElement("div", null, "Enter your email address to start"),
                React.createElement("form", { onSubmit: this.handleSubmitEmail },
                    React.createElement("div", null,
                        React.createElement("input", { type: "email", required: true, autoFocus: true, placeholder: "Email address", value: this.props.email, onChange: this.handleChangeEmail }),
                        React.createElement("input", { type: "submit", value: "Get code" })),
                    React.createElement("div", { className: "hasCode" },
                        React.createElement("a", { onClick: this.handleClickHaveCode }, "I already have a login code"))))) || (React.createElement("div", null,
                "Logging in as",
                React.createElement("a", { onClick: this.handleClickChangeEmail }, this.props.email))),
            this.props.mode === LoginReducer.Mode.EnteringCode && (React.createElement("div", null,
                React.createElement("div", null, "A login code has been sent to your email, please enter it here"),
                React.createElement("form", { onSubmit: this.handleSubmitCode },
                    React.createElement("input", { type: "tel", pattern: "[0-9]*", required: true, autoFocus: true, placeholder: "Login code", value: this.props.code, onChange: this.handleChangeCode }),
                    React.createElement("input", { type: "submit", value: "Play!" })))),
            (this.props.mode === LoginReducer.Mode.SubmittingEmail ||
                this.props.mode === LoginReducer.Mode.SubmittingCode) && (React.createElement(spinner_1.Spinner, null))));
    };
    Component.prototype.handleSubmitEmail = function (e) {
        e.preventDefault();
        this.props.onSubmitEmail(this.props.email);
    };
    Component.prototype.handleSubmitCode = function (e) {
        e.preventDefault();
        this.props.onSubmitCode(this.props.email, this.props.code);
    };
    Component.prototype.handleClickHaveCode = function (e) {
        e.preventDefault();
        var form = (e.currentTarget.parentElement.parentElement);
        if (form.reportValidity()) {
            this.props.onChangeMode(LoginReducer.Mode.EnteringCode);
        }
    };
    Component.prototype.handleClickChangeEmail = function (e) {
        e.preventDefault();
        this.props.onChangeMode(LoginReducer.Mode.EnteringEmail);
    };
    Component.prototype.handleChangeCode = function (e) {
        this.props.onChangeCode(e.target.value);
    };
    Component.prototype.handleChangeEmail = function (e) {
        this.props.onChangeEmail(e.target.value);
    };
    return Component;
}(React.PureComponent));
exports.Component = Component;
function mapStateToProps(state) {
    return {
        code: state.pages.login.code,
        email: state.pages.login.email,
        mode: state.pages.login.mode,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onChangeCode: function (code) { return dispatch(LoginReducer.updateCode(code)); },
        onChangeEmail: function (email) { return dispatch(LoginReducer.updateEmail(email)); },
        onChangeMode: function (mode) { return dispatch(LoginReducer.updateMode(mode)); },
        onSubmitCode: function (email, code) { return dispatch(LoginReducer.submitCode(email, code)); },
        onSubmitEmail: function (email) { return dispatch(LoginReducer.submitEmail(email)); },
    };
}
exports.Container = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Component);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js